<div class="manual-online-component">
  <div class="row header" #header>
    <div class="col-10">
      <mat-icon class="icon-order" svgIcon="ico-user-manual"></mat-icon>
      <span class="title">{{ title }}</span>
    </div>
    <div class="col-2 txt-right">
      <mat-icon class="icon-close-btn pointer" (click)="close()" svgIcon="close-btn"></mat-icon>
    </div>
  </div>
  <div class="spinner" *ngIf="loading">
    <app-spinner-loading></app-spinner-loading>
  </div>
  <div *ngIf="!loading" id="scrollable-area" class="scrollable-body" (scroll)="onScroll($event)">
    <div class="version">Versão: 12.09.22 (4.1.3)</div>
    <div class="row">
      <div class="col-3 stackedit__left p-0">
        <div class="stackedit__toc">
          <ul>
            <li><a (click)="goToLink('#bem-vindo-ao-seu-home-broker')">Bem-vindo ao seu Home Broker</a></li>
            <li><a (click)="goToLink('#requisitos-mínimos')">Requisitos mínimos</a>
              <ul>
                <li><a (click)="goToLink('#resolução-de-tela')">Resolução de tela</a></li>
                <li><a (click)="goToLink('#navegadores-compatíveis')">Navegadores compatíveis</a></li>
              </ul>
            </li>
            <li><a (click)="goToLink('#segurança-e-dados-pessoais')">Segurança e dados pessoais</a>
              <ul>
                <li *ngIf="wlConfig.system.isMultiBroker || isRanking">
                  <a (click)="goToLink('#realizando-o-cadastro-na-plataforma')">Realizando o cadastro na plataforma</a>
                </li>
                <li><a (click)="goToLink('#login')">Login</a></li>
                <li><a (click)="goToLink('#autenticação-forte-do-cliente')">Autenticação forte do cliente</a>
                  <ul>
                    <li><a (click)="goToLink('#dupla-autenticação')">Dupla Autenticação</a></li>
                  </ul>
                </li>
                <li *ngIf="showDoubleAuthEletronicSignature && showChangeEletronicSignature">
                  <a (click)="goToLink('#alterando-minha-assinatura-eletrônica')">Alterando minha assinatura
                    eletrônica</a>
                </li>
                <li *ngIf="isMultibroker || isRanking">
                  <a (click)="goToLink('#conectar-com-corretora')">Conectar com corretora</a>
                  <ul>
                    <li><a (click)="goToLink('#simulador')">Simulador</a></li>
                  </ul>
                </li>
              </ul>
            </li>
            <li *ngIf="showChangePassword"><a (click)="goToLink('#alterando-minha-senha')">Alterando minha senha</a>
            </li>
            <li><a (click)="goToLink('#conhecendo-o-seu-home-broker')">Conhecendo o seu Home Broker</a>
              <ul>
                <li><a (click)="goToLink('#personalizando-a-área-de-trabalho')">Personalizando a área de trabalho</a>
                </li>
              </ul>
            </li>
            <li><a (click)="goToLink('#iniciando-no-seu-home-broker')">Iniciando no seu Home Broker</a>
              <ul>
                <li><a (click)="goToLink('#conheça-sua-área-de-trabalho')">Conheça sua área de trabalho</a></li>
                <ul>
                  <li><a (click)="goToLink('#menu-superior')">Menu Superior</a></li>
                  <li><a (click)="goToLink('#submenu')">Submenu (Sidebar)</a></li>
                </ul>
              </ul>
            </li>
            <li><a (click)="goToLink('#principais-funcionalidades')">Principais Funcionalidades</a>
              <ul>
                <li><a (click)="goToLink('#market-data')">Market Data</a></li>
                <ul>
                  <li><a (click)="goToLink('#planilha-de-cotação')">Planilha de cotação</a></li>
                  <li><a (click)="goToLink('#gráfico-de-cotação')">Gráfico de Cotação</a></li>
                  <li><a (click)="goToLink('#resumo-do-ativo')">Resumo do ativo</a></li>
                  <li><a (click)="goToLink('#livro-de-ofertas')">Livro de ofertas</a></li>
                  <li><a (click)="goToLink('#negócios-realizados-times--trades')">Negócios Realizados (Times
                      &amp;Trades)</a></li>
                  <li><a (click)="goToLink('#volume-por-preço-volume-at-price')">Volume por Preço (Volume at Price)</a>
                  </li>
                  <li><a (click)="goToLink('#notícias')">Notícias</a></li>
                  <li><a (click)="goToLink('#maiores-do-dia')">Maiores do Dia</a></li>
                  <li><a (click)="goToLink('#ativos-em-leilão')">Ativos em Leilão</a></li>
                </ul>
                <li><a (click)="goToLink('#negociação')">Negociação</a></li>
                <ul>
                  <li><a (click)="goToLink('#enviar-boleta-de-compra-ou-venda-simples')">Enviar ordem (compra ou venda)
                      a partir da Boleta Simples</a></li>
                  <li *ngIf="showSuitability"><a (click)="goToLink('#assinando-termo-de-desenquadramento')">Assinando
                      termo de desenquadramento</a></li>
                  <li><a (click)="goToLink('#enviar-boleta-de-compra-ou-venda-stop')">Enviar ordem (compra ou venda) a
                      partir da Boleta Stop</a></li>
                  <li><a (click)="goToLink('#enviar-boleta-de-compra-ou-venda-dom')">Enviar ordem (compra ou venda) a
                      partir da Boleta DOM</a></li>
                  <li><a (click)="goToLink('#utilizando-ferramenta-de-boleta-na-área-de-trabalho')">Utilizando
                      ferramenta
                      de Boleta na Área de Trabalho</a></li>
                  <li><a (click)="goToLink('#utilizando-ferramenta-de-boleta-rápida-na-área-de-trabalho')">Utilizando
                      ferramenta de Boleta Rápida na Área de Trabalho</a></li>
                  <li><a (click)="goToLink('#consultando-as-informações-do-financeiro')">Consultando as
                      informações do Patrimônio</a></li>
                  <li><a (click)="goToLink('#realizando-a-consulta-de-ordens')">Realizando a consulta de ordens</a></li>
                  <li><a (click)="goToLink('#consulta-de-custódia')">Consulta de custódia</a></li>
                  <li *ngIf="showSideBarBrokerageNote"><a (click)="goToLink('#nota-de-corretagem')">Nota de
                      corretagem</a></li>
                  <li *ngIf="showSideBarExtract"><a (click)="goToLink('#extrato')">Extrato</a></li>
                  <li *ngIf="showSideBarMenuDeposit"><a (click)="goToLink('#resgate-e-depósito')">Resgate e Depósito</a>
                  </li>
                </ul>
              </ul>
            </li>
            <li><a (click)="goToLink('#entre-em-contato-com-nossa-equipe')">Entre em contato com nossa equipe</a></li>
            <ul>
              <li><a (click)="goToLink('#canais')">Canais de atendimento</a></li>
            </ul>
          </ul>
        </div>
      </div>

      <div class="col-9 stackedit__right p-0">
        <div class="stackedit__html">
          <h1 class="mp-0" id="bem-vindo-ao-seu-home-broker">Bem-vindo ao seu Home Broker</h1>
          <h1 id="requisitos-mínimos">Requisitos mínimos</h1>
          <h2 id="resolução-de-tela">Resolução de tela</h2>
          <p>Nossa plataforma apresenta um sistema responsivo caso você esteja utilizando um equipamento com a resolução
            de
            1280px.</p>
          <p>As resoluções de tela suportadas pelo <strong>Home Broker</strong> são:</p>
          <ul>
            <li>1920 x 1080;</li>
            <li>1600 x 900;</li>
            <li>1440 x 900;</li>
            <li>1366 x 768;</li>
            <li>1280 x 1024;</li>
          </ul>
          <h2 id="navegadores-compatíveis">Navegadores compatíveis</h2>
          <p>Para que você possa desfrutar adequadamente o <strong>Home Broker</strong>, será necessário utilizar alguns
            dos
            seguintes browsers compatíveis:</p>
          <ul>
            <li>Google Chrome 55 ou superior;</li>
            <li>Mozilla Firefox 60 ou superior;</li>
            <li>Safari 10 ou superior;</li>
            <li>Opera.</li>
          </ul>
          <h1 id="segurança-e-dados-pessoais">Segurança e dados pessoais</h1>
          <h2 id="realizando-o-cadastro-na-plataforma" *ngIf="wlConfig.system.isMultiBroker || isRanking">Realizando o
            cadastro na plataforma</h2>
          <p *ngIf="wlConfig.system.isMultiBroker || isRanking">Para iniciar sua jornada utilizando o <strong>Home
              Broker</strong>, é necessário informar alguns dados pessoais e que também informe um pouco mais sobre suas
            experiências com mercado financeiro. Caso não possua experiência, não se preocupe, você está no lugar certo
            lugar certo para iniciar sua caminhada.</p>
          <p *ngIf="wlConfig.system.isMultiBroker || isRanking">Após finalizar seu cadastro, você receberá um e-mail
            contendo seu <strong>usuário</strong> e <strong>senha de acesso</strong> ao <strong>Home Broker</strong>.
          </p>
          <p *ngIf="wlConfig.system.isMultiBroker || isRanking">Caso deseje, você poderá alterar a sua senha de acesso
            posteriormente.
          </p>
          <p *ngIf="wlConfig.system.isMultiBroker || isRanking">Para realização do CADASTRO e abertura de conta para
            negociação, favor procurar sua Corretora para Contrato de Intermediação e Custódia ou procure seu gerente
            para assinar o contrato.</p>
          <h2 id="login">Login</h2>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_1.png" alt="" title="Tela de Login"></p>
          <p *ngIf="showFormLogin">Na tela de login do <strong>Home Broker</strong> você deverá inserir as credenciais
            que lhe foram enviadas
            no e-mail informado durante o seu cadastro e selecionar a opção “<strong>Entrar</strong>”. Você pode
            visualizar a sua senha habilitando o ícone de exibição ao fim do campo onde você digitará sua senha.</p>
          <p *ngIf="wlConfig.system.isMultiBroker || isRanking">Caso você ainda não tenha realizado o cadastro, você
            poderá fazê-lo selecionando a opção “Crie sua conta” que se encontra logo abaixo do botão
            “<strong>Entrar</strong>”.</p>
          <blockquote>
            <p><strong>Nota</strong>: Caso a senha que você informe esteja incorreta, após a “X” tentativa, suas
              credenciais serão bloqueadas e se isso acontecer, você pode estar entrando em contato com nossa equipe de
              suporte e nosso time estará apto a realizar o desbloqueio.
              Além disso, seu login tanto para Market Data, quanto para negociação, são únicos, ou seja, caso você
              esteja logado em um dispositivo e tente logar em outro, você será automaticamente desconectado do outro
              dispositivo.</p>
          </blockquote>
          <p>Se dará de forma transparente através de uma opção existente na plataforma da sua corretora.</p>
          <h2 id="autenticação-forte-do-cliente">Autenticação forte do cliente</h2>
          <p>Após inserir suas credenciais de acesso e ser autenticado na plataforma, você ainda deverá passar por uma
            nova autenticação, dentro da plataforma, visando ainda mais sua segurança durante suas operações e seguindo
            um padrão estabelecido pela bolsa de valores.</p>
          <h3 id="dupla-autenticação">Dupla Autenticação</h3>
          <!-- TODO: Passar a variavel da tela de login informando qual o tipo de segundo fator -->
          <!-- <p> Para garantir ainda mais sua segurança, será solicitada uma segunda
            autenticação no momento de acesso ao Home Broker, que consiste digitar o código que foi enviado via SMS ou
            e-mail, e assim, você estará
            apto a acessar o <strong>Home Broker</strong>.</p> -->
          <p *ngIf="showDoubleAuthAfc">Para garantir ainda mais sua segurança, será solicitada uma segunda autenticação
            no momento de login na plataforma, que consiste em responder a uma pergunta (selecionada aleatoriamente
            dentre uma série de perguntas) e assim, você estará apto a acessar o <strong>Home Broker</strong>.</p>
          <p *ngIf="showDoubleAuthAfc"> As perguntas consistem em responder informações já informadas por você durante a
            etapa de cadastro em nossa plataforma, então fique tranquilo, você será capaz de responder a pergunta
            sorteada para você sem qualquer dificuldade.</p>
          <blockquote *ngIf="showDoubleAuthAfc">
            <p><strong>Nota</strong>: Lembre-se que após a terceira tentativa incorreta de inserir a resposta certa, a
              tela da dupla autenticação será recarregada e uma nova pergunta será exibida para você.</p>
          </blockquote>
          <p>Para garantir ainda mais sua segurança, será solicitada uma segunda autenticação no momento em for realizar
            uma negociação. Será seu código de segurança, o mesmo já utilizado na plataforma da sua corretora.</p>
          <h3 *ngIf="showDoubleAuthEletronicSignature" id="assinatura-eletrônica">Código de Segurança e/ou Assinatura
            Eletrônica</h3>
          <p *ngIf="showDoubleAuthEletronicSignature">A <strong>assinatura eletrônica</strong> é uma maneira de garantir
            ainda mais segurança para você realizar sua operações.</p>
          <p *ngIf="showDoubleAuthEletronicSignature">É uma assinatura que será utilizando antes de ser finalizada uma
            operação e pode ser salva, para te garantir ainda mais comodidade, para operar de modo seguro e rápido.</p>
          <p *ngIf="showDoubleAuthEletronicSignature">O código de segurança é uma maneira de garantir ainda mais
            segurança para você realizar suas operações. É um código que será utilizando antes de ser finalizada uma
            operação e pode ser salva, para te garantir ainda mais comodidade, para operar de modo seguro e rápido.</p>
          <p *ngIf="showDoubleAuthEletronicSignature">Ao finalizar seu cadastro em sua corretora, você receberá a
            assinatura eletrônica juntamente com seu usuário de acesso.</p>
          <h2 id="alterando-minha-assinatura-eletrônica"
            *ngIf="showDoubleAuthEletronicSignature && showChangeEletronicSignature">
            Alterando minha assinatura eletrônica
          </h2>
          <p *ngIf="showDoubleAuthEletronicSignature && showChangeEletronicSignature">É possível realizar a alteração da
            sua assinatura eletrônica através do menu “<strong>Minha conta</strong>” e depois “<strong>Alterar
              assinatura eletrônica</strong>”.
          </p>
          <p *ngIf="showDoubleAuthEletronicSignature && showChangeEletronicSignature">Os requisitos para sua nova
            assinatura eletrônica devem ser:</p>
          <ul *ngIf="showDoubleAuthEletronicSignature && showChangeEletronicSignature">
            <li>A assinatura deve conter 6 caracteres;</li>
            <li>Utilize <strong>somente</strong> números.</li>
          </ul>
          <blockquote *ngIf="showDoubleAuthEletronicSignature && showChangeEletronicSignature">
            <p><strong>Nota</strong>: É necessário informar sua assinatura eletrônica antiga para que seja possível
              alterar para uma nova assinatura.</p>
          </blockquote>
          <h2 *ngIf="isMultibroker || isRanking" id="conectar-com-corretora">Conectar com corretora</h2>
          <p *ngIf="isMultibroker || isRanking"> Para garantir ainda mais segurança, após realizar a primeira
            autenticação
            na tela de login (utilizando suas credenciais de difusão) e com isso, ter acesso ao conteúdo de Market Data,
            você
            deverá realizar a autenticação com a sua corretora (caso utilize a versão Multibroker) para realizar
            operações na
            bolsa de valores.
          </p>
          <p *ngIf="isMultibroker || isRanking">Após acessar a plataforma, selecione a opção “Autenticar com sua
            corretora”
            no submenu, selecione sua corretora e insira suas credenciais fornecidas pela corretora (credenciais de
            negociação).
          </p>
          <p *ngIf="isMultibroker || isRanking"><img src="assets/images/clients/{{broker}}/manual/IMG_78.png" alt=""
              title="Conectar com corretora">
          </p>
          <p>
          <h3 *ngIf="isMultibroker || isRanking" id="simulador"> Simulador></h3>
          <p *ngIf="isMultibroker || isRanking">Caso deseje operar de forma a aprender mais sobre o mercado e treinar
            para que possa se tornar expert no mercado
            de ações, você poderá conectar em nosso simulador, podendo testar suas estratégias e aprimorando seus
            conhecimentos.
          </p>
          <p>Para isso, selecione a opção “Simulador” e em seguida, “Entrar”.</p>
          <h2 *ngIf="showChangePassword" id="alterando-minha-senha">Alterando minha senha</h2>
          <p *ngIf="showChangePassword">Você poderá realizar a alteração de sua senha de acesso a plataforma quando
            quiser.</p>
          <p *ngIf="showChangePassword">Para alterar sua senha, selecione o menu “<strong>Minha conta</strong>” e depois
            “<strong>Alterar senha</strong>”.</p>
          <p *ngIf="showChangePassword">E para garantir uma melhor segurança, recomendamos que você siga os requisitos
            listados abaixo:</p>
          <ul *ngIf="showChangePassword">
            <li>Pelo menos 8 caracteres;</li>
            <li>Utilize números;</li>
            <li>Utilize pelo menos uma letra minúscula;</li>
            <li>Utilize pelo menos uma letra maiúscula;</li>
            <li>Utilize pelo menos um caractere especial.</li>
          </ul>
          <h1 id="conhecendo-o-seu-home-broker">Conhecendo o seu Home Broker</h1>
          <p>Agora que você já conhece nossos principais pontos de segurança e sabe quais são as informações necessárias
            para utilizar o <strong>Home Broker</strong>, vamos introduzi-lo à um passo a passo para que você acesse e
            utilize devidamente a nossa plataforma.</p>
          <p>Esperamos que no fim da leitura deste manual, você já se sinta familiarizado com a ferramenta e que
            desfrute ao máximo o que o <strong>Home Broker</strong> pode oferecer.</p>
          <p>Boa leitura!</p>
          <h2 id="personalizando-a-área-de-trabalho">Personalizando a área de trabalho</h2>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_3.png" alt="" title="Personalizar área de trabalho">
          </p>
          <p>Após passar pela etapa de <strong>Login</strong></p>
          <p>Para iniciar seus investimentos, primeiro iremos te auxiliar a organizar a sua <strong>área de
              trabalho</strong> de acordo com sua preferência.</p>
          <p>Inicialmente, você terá uma área de trabalho "Padrão". Caso deseje criar uma área de trabalho
            personalizada, você poderá acessar dentro do Home Broker a opção "Criar área de trabalho" no menu superior e
            depois criar uma área de acordo com suas preferências, selecionando a opção "Personalize o seu" ou
            selecionando uma nova área de trabalho "Padrão".</p>
          <blockquote>
            <p><strong>Nota</strong>: Lembre-se que você poderá ter no máximo 4 (quatro) áreas de trabalho em seu Home
              Broker. </p>
          </blockquote>
          <p>Abaixo explicamos como funciona cada uma das áreas de trabalho pré-definidas:</p>
          <ul>
            <li>
              <p><strong>Padrão:</strong>: é uma área de trabalho que visa auxiliar os investidores a tomarem
                decisões mais assertivas no momento de investir, oferecendo informações diversificadas sobre o mercado e
                sendo apresentadas em diferentes tópicos. Aqui você irá encontrar os principais ativos do mercado
                financeiro.</p>
            </li>
            <li>
              <p><strong>Personalize o seu</strong>: uma área de trabalho que poderá ser configurada de acordo com sua
                preferência, onde você poderá adicionar planilhas de cotações, gráficos, informações sobre Negócios
                Realizados e muitas outras opções para que você trabalhe com toda comodidade.</p>
            </li>
          </ul>
          <p>Você pode adicionar um nome personalizado para sua área de trabalho ou alterar o nome de uma existente.
            Após selecionar umas das opções pré-definidas, selecione a opção “<strong>Iniciar</strong>” para ser
            redirecionado para área de trabalho propriamente dita.</p>
          <p>Caso opte pela opção “<strong>Personalize o seu</strong>”, você será redirecionado para a tela abaixo:</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_4.png" title="Personalizando Área de Trabalho">
          </p>
          <p>Você encontrará as seguintes ferramentas que poderão ser adicionados em sua planilha:</p>
          <ul>
            <li>Resumo do Ativo;</li>
            <li>Planilha de Cotação;</li>
            <li>Volume no Preço;</li>
            <li>Negócios Realizados;</li>
            <li>Livro de Ofertas;</li>
            <li>Gráficos;</li>
            <li>Boleta Rápida;</li>
            <li>Boleta;</li>
            <li>Notícias;</li>
            <li>Maiores do Dia;</li>
            <li>Posição do Dia;</li>
            <li>Ordens.</li>
          </ul>
          <p>Para adicionar as ferramentas de sua preferência, basta selecionar a opção “<strong>+</strong>” e caso
            queira, poderá digitar o <strong>nome do ativo</strong> desejado (como por exemplo: PETR4, VALE3, etc),
            selecioná-lo dentre as opções exibidas e selecionar o ativo e clicar no ícone “<strong>+</strong>”.</p>
          <p>Feito isso, as ferramentas e os respectivos ativos selecionados serão exibidas na coluna ao lado direito
            (conforme a imagem abaixo) e após selecionar a opção “<strong>Adicionar ferramentas</strong>”, sua área de
            trabalho será criada e você será redirecionado automaticamente para ela.</p>
          <p>E lembre-se, a quantidade máxima de <strong>ferramentas</strong> que podem ser adicionadas na área de
            trabalho são <strong>{{ maxCardItemWks }}</strong>, então organize-se.</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_5.png" alt=""
              title="Personalizando Área de Trabalho"></p>
          <blockquote>
            <p><strong>Nota</strong>: As ferramentas disponíveis serão detalhadas posteriormente em cada uma de suas
              respectivas sessões. Vale ressaltar que todas as configurações aplicadas em cada ferramenta serão salvas,
              visando uam experiência ainda mais agradável para sua próxima sessão.</p>
          </blockquote>
          <h1 id="iniciando-no-seu-home-broker">Iniciando no seu Home Broker</h1>
          <h2 id="conheça-sua-área-de-trabalho">Conheça sua área de trabalho</h2>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_6.png" alt="" title="Área de Trabalho"></p>
          <p>Bom caro investidor, aqui estamos em sua área de trabalho já organizada e pronta para uso.</p>
          <p>Queremos que você conheça os principais recursos que nossa plataforma tem á oferecer e temos certeza que
            logo você estará habituado com o <strong>Home Broker</strong>".</p>
          <p>Primeiramente iremos lhe apresentar os menus principais que poderão ser acessados durante sua experiência.
          </p>
          <h3 id="menu-superior">Menu Superior</h3>
          <p>O menu superior, é composto por algumas configurações importantes e irão te auxiliar durante o tempo em que
            você estiver utilizando a plataforma e será onde você terá acesso a diversas áreas do Home Broker, podendo
            visualizar seus investimentos, saldo e entres outras informações.</p>
          <ul>
            <li>
              <p><strong>Alternar Área de Trabalho</strong>: opção para alternar entre as áreas de trabalho do usuário,
                onde
                as áreas poderão ser distinguidas de acordo com o nome atribuído pelo usuário, além de ter a opção para
                criar uma
                área de trabalho. O comportamento aqui é o mesmo apresentado a você no momento inicial de configuração
                de sua área
                de trabalho; </p>
            </li>
            <li>
              <p><strong>Conteúdos</strong>: opção para exibir conteúdos relacionados ao mercado financeiro e ao Home
                Broker,
                além de acessar as principais notícias do mercado e materiais educacionais. Ao acessar essa opção, você
                verá
                os seguintes itens:</p>
              <ul>
                <li>
                  <p><strong>Investimentos e Notícias</strong>: ferramenta que será inserida em sua área de trabalho, apresentando as
                    principais
                    notícias da agência Investimentos e Notícias;</p>
                </li>
                <li>
                  <p><strong>Notícias: </strong>: ferramenta que será inserida em sua área de trabalho e permitirá a
                    você acompanhar
                    os principais acontecimentos do mercado financeiro e pesquisar sobre as notícias que você deseja;
                  </p>
                </li>
                <li>
                  <p><strong>Pesquisa de Notícias</strong>: opção para buscar as notícias desejadas;</p>
                </li>
                <li>
                  <p><strong>Carteiras Recomendadas</strong>: opção que irá redirecionar você para uma página
                    apresentando informações
                    sobre as principais carteiras de ativos do mercado;</p>
                </li>
                <!-- TODO: Ainda não existe no sistema -->
                <!-- <li>
                  <p><strong>Canal no Youtube</strong>: opção que irá redirecionar você para a página do Home Broker no
                    YouTube;</p>
                </li> -->
                <li *ngIf="isRanking">
                  <p><strong>Material Educacional</strong>: opção que irá redirecionar você para uma página contendo
                    materiais educacionais
                    sobre informações referentes ao mercado financeiro. </p>
                </li>
              </ul>
            </li>
            <li>
              <p><strong>Ferramentas</strong>: selecionando essa opção, será aberto para você um menu, onde você poderá
                adicionar novos ativos em sua área de trabalho, sendo que você poderá escolher qual módulo irá inserir,
                sendo as opções: Planilha de Cotação, Resumo do Ativo, Livro de Ofertas, Negócios Realizados, Volume por
                Preço,
                Gráficos e Top:Maiores Altas e Baixas. </p>
            </li>
            <li>
              <p><strong>Negociação</strong>: espaço onde você poderá acessar as principais opções de negociação da
                plataforma, onde
                terá acesso as seguintes informações:<strong>Acompanhar Ordens, Boleta Rápida, Boleta Simples e Posição
                  do dia</strong>.
                Ao selecionar uma dessas opções, uma nova ferramenta com o nome da respectiva opção selecionada será
                inserida em sua
                área de trabalho;</p>
              <ul>
                <li>
                  <p><strong>Boleta Simples</strong>: ferramenta que permite o envio de ordens com base nas informações
                    e valores
                    atribuídos por você;</p>
                </li>
                <li>
                  <p><strong>Boleta Rápida</strong>: ferramenta que permite o envio de ordens ao mercado de maneira
                    rápida, visualizando
                    otimizar o seu tempo durante seus investimentos;</p>
                </li>
                <li>
                  <p><strong>Mega DOM</strong>: ferramenta que permite o envio de ordens ao mercado de maneira
                    mais robusta, onde permite ao investidor visualizar um Book Escada para melhor auxiliá-lo em suas
                    operações;</p>
                </li>
                <li>
                  <p><strong>Posição do Dia</strong>: ferramenta que permite que você visualize a posição do dia para
                    cada um dos
                    seus ativos de sua carteira.</p>
                </li>
                <li>
                  <p><strong>Ordens do dia</strong>: ferramenta que permite que você visualize suas ordens ao longo do
                    dia.</p>
                </li>
                <li>
                  <p><strong>Relatórios</strong>: opção onde você terá acesso aos principais relatórios do seu Home
                    Broker, apresentando informações como:
                    {{ !showSideBarExtract && !showSideBarBrokerageNote
                    ? 'Histórico de Ordens;' : 'Histórico de Ordens'}}
                    {{ showSideBarExtract ? ', Extrato Financeiro' : '' }}
                    {{ showSideBarBrokerageNote ? ', Nota de Corretagem' : ''}}</p>
                  <ul>
                    <li>
                      <p><strong>Minha Custódia</strong>:espaço onde você poderá visualizar seus ativos que foram
                        negociados em ambos
                        os mercados (Bovespa e BM&F), visualizar sua posição do dia e poderá aplicar filtros de sua
                        preferência;</p>
                    </li>
                    <li *ngIf="showSideBarExtract">
                      <p><strong>Extrato Financeiro</strong>: espaço onde você poderá todas as informações referentes ao
                        extrato da sua conta;</p>
                    </li>
                    <li>
                      <p><strong>Histórico de Ordens</strong>: espaço que permite a visualização de todo o seu histórico
                        de
                        envio de ordens, além de poder
                        aplicar filtros à sua preferência.</p>
                    </li>
                    <li *ngIf="showSideBarBrokerageNote">
                      <p><strong>Nota de Corretagem</strong>: espaço onde você poderá visualizar todas as informações
                        referentes as notas de corretagem
                        de suas operações;</p>
                    </li>
                    <li *ngIf="showSideBarMenuDeposit">
                      <p><strong>Depósito/Resgate</strong>: espaço onde você poderá realizar a transferência do valor de
                        sua
                        escolha que
                        você possui em um determinado ativo ou depositar um valor para que você possa continuar operando
                        no
                        seu Home Broker.</p>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <!-- TODO: Ainda não existe no sistema -->
            <!-- <li>
              <p><strong>Mercados</strong>: opção para visualizar as principais informações do mercado internacional,
                apresentando informações como: <strong>Resumo das Bolsas</strong> , <strong>World Indices</strong> e
                <strong>Moedas</strong>;
              </p>
            </li> -->
            <li *ngIf="isRanking">
              <p><strong>Desafio</strong>: opção para visualizar as informações sobre o Desafio de Investimentos,
                apresentando informações como: <strong>Ranking</strong> e <strong>Material Educacional;</strong> </p>
            </li>
            <li *ngIf="isAssessor">
              <p><strong>Assessor</strong>: opção para visualizar as todos os menus (áreas de trabalho) que o assessor
                possui; </p>
            </li>
            <li>
              <p><strong>Boleta de compra/Boleta de venda:</strong> opção ativar a boleta na sua área de trabalho.
                Para abrir uma boleta de compra, selecione o ícone <img
                  src="assets/images/clients/{{broker}}/manual/IMG_70.png" alt="" title="Boleta Compra">.
                Para abrir uma boleta de venda, selecione o ícone <img
                  src="assets/images/clients/{{broker}}/manual/IMG_71.png" alt="" title="Boleta Venda">.</p>
            </li>
            <li>
              <p><strong>Tempo de sessão</strong>: você pode acompanhar o tempo em que a sessão irá expirar caso
                esteja inativo na plataforma. Quando o relógio atingir o tempo <strong>00:00:00</strong> você será
                desconectado da plataforma.</p>
            </li>
            <li>
              <p><strong>Ícones de status dos servidores</strong>: opção representada pelos ícones <img
                  src="assets/images/clients/{{broker}}/manual/IMG_8.png" alt="">, que simbolizam o status da conexão
                dos servidores de Market Data e Negociação (sendo representados pelos ícones da esquerda para direita,
                respectivamente). Quando os ícones estão simbolizados pela cor <strong>verde</strong>, significa que os
                servidores estão online, ou seja, funcionando normalmente. Se os ícones estiverem simbolizados pela cor
                <strong>vermelha</strong>, há situações diferentes, como podem ser visualizadas abaixo:
              <ul>
                <li>
                  <p><strong>Market Data</strong>: significa que os serviços de Market Data estão offline;
                </li>
                <li>
                  <p><strong>Negociação</strong>: significa que o usuário de negociação não está conectado.
                </li>
              </ul>
              <p>Vale lembrar que só serão exibidos os dois ícones de status quando você estiver conectado tanto no
                usuário de Market Data, quanto no usuário de negociação. Caso conectado somente no usuário de Market
                Data, deverá ser exibido somente o ícone de status referente ao Market Data.</p>
            </li>
            <br>
            <li>
              <p><strong>Criar área de trabalho</strong>: opção para criar uma nova área de trabalho. O comportamento
                aqui é o mesmo apresentado a você no momento inicial de configuração de sua área de trabalho.</p>
            </li>
            <li>
              <p><strong>Configurações</strong>: menu podendo exibir dados do usuário, onde você poderá ativar/desativar
                o <strong>Tema Escuro (Dark)</strong>.
                <span *ngIf="showChangePassword">Poderá também <strong>alterar sua senha</strong>.</span>
                <span *ngIf="showChangeEletronicSignature">Alterar sua <strong>assinatura eletrônica</strong>.</span>
                Acessar este <strong>manual</strong>, <strong>Canais de atendimento</strong> e onde também realizará o
                "Logout" (Sair)
                do <strong> Home Broker</strong>.
                <span *ngIf="showUrlStore">Além disso, informações a respeito da sua assinatura na plaataforma Fast
                  Trade poderão
                  ser visualizadas nas opções <strong>Meu Plano e Assinaturas</strong> e <strong>Pacotes
                    Extras</strong>.</span>
                Para acessar essas <strong>Configurações</strong>, selecione o ícone
                <img src="assets/images/clients/{{broker}}/manual/IMG_50.png" alt="">.
              </p>
            </li>
            <li *ngIf="isAssessor">
              <p>Caso esteja logado como perfil de <strong>Assessor</strong>, aqui será exibido o seu nome. O nome do
                cliente selecionado, será exibido no menu lateral, conforme descrito na seção <strong>Submenu
                  (Sidebar)</strong>.</p>
            </li>
          </ul>
          <h3 id="submenu">Submenu (Sidebar)</h3>
          <p>O submenu, localizado logo abaixo do menu superior, apresenta algumas informações relevantes em relação as
            contas do usuário,
            quanto a seu perfil de investidor e também sobre as principais notícias de mercado.
          </p>
          <p>As opções disponíveis são:</p>
          <ul>
            <li *ngIf="showSuitability">
              <p><strong>Perfil do Investidor</strong>: espaço para exibir qual o perfil do investidor (perfil de
                suitability do cliente). O perfil de suitability é obtido após preencher o formulário sobre perfil de
                investidor da sua corretora e ele exercerá influência sobre os tipos de ativos que você pode negociar no
                mercado;</p>
            </li>
            <li *ngIf="isAssessor">
              <p>Caso esteja logado como perfil de <strong>Assessor</strong>, será exibido a foto e o nome do
                cliente previamente selecionado na tela de Clientes. Ao selecionar o ícone, é possível buscar e
                alterar
                entre clientes;</p>
            </li>
            <li *ngIf="isAssessor">
              <p>O <strong>Assessor</strong> consegue visualizar todos os clientes que estão vinculados a sua conta.
              </p>
            </li>
            <li>
              <p><strong>Contas</strong>: espaço para exibir o número da conta do usuário, sendo possível alterar entre
                as contas
                do usuário;</p>
            </li>
            <li>
              <p><strong>Em destaque</strong>: campo onde será exibido as principais notícias sobre o mercado
                financeiro.</p>
            </li>
          </ul>
          <blockquote>
            <p><strong>Nota</strong>: As opções acima serão mais detalhadas no decorrer do manual em Market Data e
              Negociação.</p>
          </blockquote>
          <h1 id="principais-funcionalidades">Principais Funcionalidades</h1>
          <h4 id="market-data">Market Data</h4>
          <p>Quando dizemos o termo Market Data queremos no referir ao serviço disponibilizado pela B3, que permite que
            nós
            obtenhamos informações e notícias sobre o mercado financeiro, referente aos papéis que são negociados na
            bolsa.
          </p>boleta
          <p>Conheça um pouco mais sobre as informações referente a Market Data que você poderá visualizar utilizando o
            <strong>Home Broker</strong>.
          </p>
          <h2 id="planilha-de-cotação">Planilha de Cotação</h2>
          <p>A <strong>Planilha de Cotação</strong> é uma ferramenta onde você consegue visualizar todas as informações
            importantes de um ou vários ativos, podendo ser personalizado de acordo com sua preferência.<br>
            <img src="assets/images/clients/{{broker}}/manual/IMG_10.png" alt="" title="Planilha de cotação">
          </p>
          <h3 id="renomeando-a-planilha-de-cotação">Renomeando a planilha de cotação</h3>
          <p>Para renomear a planilha, basta selecionar o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_11.png" alt="" title="Renomear planilha"> e digitar o
            nome
            de
            sua preferência.</p>
          <h3 id="adicionar-ativos-na-planilha">Adicionar ativos na planilha</h3>
          <p>Para adicionar um novo ativo selecionando a opção " <strong>+ Adicionar Ativo</strong>" e em seguida
            inserir o símbolo do ativo desejado.</p>
          <h3 id="remover-ativos-na-planilha-ou-remover">Remover ativos na planilha ou remover</h3>
          <p>Caso queira remover um ou mais ativos da planilha, você pode selecionar a caixa de seleção ao lado de nome
            do
            ativo que pretende excluir e em seguida<br>
            selecionar a opção “<strong>Excluir ativo(s)</strong>”.</p>
          <p>Vale lembrar que, caso queira excluir todos os ativos da planilha, você pode selecionar a caixa de seleção
            ao
            lado da palavra “<strong>Ativo</strong>” e clicar na opção “<strong>Excluir ativos</strong>”.</p>
          <blockquote>
            <p><strong>Nota</strong>: Lembre-se que o número máximo de ativos que podem ser adicionados na planilha de
              cotação são <strong>20</strong> ativos. Caso você tente ultrapassar esse número, será exibida uma mensagem
              informativa, dizendo que o número máximo de ativos não pode ser excedido.</p>
          </blockquote>
          <h3 id="comprar-ou-vender-ativos-a-partir-da-planilha">Comprar ou vender ativos a partir da planilha</h3>
          <p>Caso queira comprar ou vender um ativo da planilha, você pode selecionar a caixa de seleção ao lado de nome
            do
            ativo que pretende excluir e em seguida<br>
            selecionar a opção “<strong>Comprar ativo</strong>” ou “<strong>Vender ativo</strong>”.</p>
          <p>Feito isso, a plataforma irá abrir uma <strong>boleta de compra</strong> ou de <strong>venda</strong> (de
            acordo com a opção selecionada anteriormente), permitindo que você realize o envio de uma ordem ao mercado.
          </p>
          <blockquote>
            <p><strong>Nota</strong>: É possível visualizar os botões de comprar ou vender ativo, somente se um único
              ativo
              tiver sido selecionado.</p>
          </blockquote>
          <h3 id="buscando-ativos-na-planilha-de-cotação">Buscando ativos na planilha de cotação</h3>
          <p>Para buscar um determinado ativo em sua planilha de cotação, basta selecionar o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_12.png" alt="" title="Buscando ativos"> e buscar pelo
            símbolo
            do ativo desejado.</p>
          <h3 id="habilitando-ou-removendo-colunas-da-planilha">Habilitando ou removendo colunas da planilha</h3>
          <p>Você pode adicionar ou remover colunas de sua planilha de cotação, selecionando o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_13.png" alt="" title="Habilitando ou removendo colunas">.
            Em
            seguida, basta marcar ou desmarcar as caixas de seleção presentes ao lado do nome de cada coluna e depois
            selecionar o “<strong>X</strong>” para que as alterações sejam aplicadas.</p>
          <p>Também é possível selecionar a opção “Redefinir Colunas” para voltar para sua configuração inicial ou
            simplesmente excluir todas, selecionado a opção “Limpar Colunas”.</p>
          <p>E caso você queira reordenar a posição das colunas, basta segurar e arrastá-las de lugar após selecionar o
            nome
            da coluna.</p>
          <p>As <strong>colunas disponíveis</strong> podem ser visualizadas na imagem abaixo:</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_14.png" alt=""
              title="Colunas disponíveis na planilha">
          </p>
          <blockquote>
            <p><strong>Nota</strong>: As colunas destacadas em azul são as colunas exibidas de forma padrão.</p>
          </blockquote>
          <h3 id="removendo-planilha-da-área-de-trabalho">Removendo planilha da área de trabalho</h3>
          <p>Para excluir a planilha de cotação da sua área de trabalho, você deve selecionar o ícone
            “<strong>X</strong>”
            e
            em seguida selecionar a opção “<strong>Confirmar</strong>”.</p>
          <p>Caso quisesse cancelar a ação, basta selecionar a opção “<strong>Cancelar</strong>”.</p>
          <h4 id="gráfico-de-cotação">Gráfico de Cotação</h4>
          <p>O Gráfico de Cotação é uma ferramenta onde pode-se visualizar os gráficos dos ativos que desejar, podendo
            acompanhar o valor do ativo, representada ao <strong>lado esquerdo</strong> do gráfico e visualizar a hora
            em
            que o ativo atingiu determinado valor, na <strong>parte inferior</strong> do gráfico.</p>
          <p>Quando a ferramenta do gráfico é criado pela primeira vez em sua área de trabalho, você deverá informar um
            ativo para
            que o gráfico possa ser exibido. Só é possível exibir um gráfico por ativo em sua área de trabalho. </p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_16.png" alt="" title="Gráfico de cotação"></p>
          <p>Ao posicionar o mouse em cima de um determinado <strong>ponto do gráfico</strong>, será exibido o
            <strong>valor</strong> do ativo.
            Além disso, é possível habilitar o PAD do gráfico no canto superior direito da ferramenta, assim,
            permitindo que você opere utilizando o gráfico. Ao ativar o PAD, será exibida uma mensagem informando para
            você
            que poderá operar de forma mais ágil, mas que suas ordens não serão exibidas no gráfico, porém, poderá
            acompanhá-las
            juntamente com sua posição na aba "Ordens" as ordens que estão no grupo de "Abertas".
            Além disso, você poderá selecionar se as operações serão do tipo <strong>Daytrade</strong> ou
            <strong>Position</strong>.
          </p>
          <h3 id="alterando-ativo-do-gráfico-de-cotação">Alterando ativo do gráfico de cotação</h3>
          <p>Ao selecionar o ícone <img src="assets/images/clients/{{broker}}/manual/IMG_11.png" alt=""
              title="Alterando ativo do gráfico"> no gráfico de cotação, você poderá alterar o ativo que está sendo
            exibido
            no gráfico. Basta inserir o símbolo do ativo desejado e em seguida selecioná-lo na lista exibida.
            Você poderá selecionar a opção "Gráfico" no menu lateral, será permitido a você analisá-lo de acordo com
            suas estratégias favoritas e podendo utilizar variados estudos disponíveis, fornecidos pela ferramenta
            integrada TradingView.</p>

          <p>O gráfico expandido pode ser visualizado na imagem abaixo:</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_17.png" alt="" title="Gráfico em nova aba"></p>
          <h3 id="editando-o-gráfico">Editando o gráfico</h3>
          <p>Para editar o <strong>gráfico</strong>, existem algumas configurações disponíveis, como:</p>
          <ul>
            <li>Alterar ativo;</li>
            <li>Intervalo de tempo;</li>
            <li>Estilos de barra;</li>
            <li>Configurações do Gráfico;</li>
            <li>Indicadores;</li>
            <li>Comparar/Adicionar Símbolo;</li>
            <li>Voltar/Avançar;</li>
            <li>Modo Tela Cheia;</li>
            <li>Capturar Tela;</li>
            <li>Carregar Layout do Gráfico;</li>
            <li>Salvar Layout do Gráfico.</li>
          </ul>
          <h3 id="estudos-disponíveis">Estudos disponíveis</h3>
          <p>As opções de <strong>estudos disponíveis</strong> no gráfico são:</p>
          <ul>
            <li>Linha de tendência;</li>
            <li>Canal de linhas;</li>
            <li>Pincel;</li>
            <li>Texto;</li>
            <li>Padrão XABCD;</li>
            <li>Posição Compradora;</li>
            <li>Ícone;</li>
            <li>Zoom In;</li>
            <li>Measure;</li>
            <li>Modo magnético;</li>
            <li>Stay in Drawing Mode;</li>
            <li>Bloquear todos os Desenhos;</li>
            <li>Esconder todas as ferramentas de desenho;</li>
            <li>Visualizar lista de objetos;</li>
            <li>Remover todas as ferramentas de desenho.</li>
          </ul>
          <h3 id="removendo-gráfico-de-cotação-da-área-de-trabalho">Removendo gráfico de cotação da área de trabalho
          </h3>
          <p>Para excluir o gráfico de cotação da sua área de trabalho, você deve selecionar o ícone
            “<strong>X</strong>”
            e
            em seguida selecionar a opção “<strong>Confirmar</strong>”.</p>
          <p>Caso quisesse cancelar a ação, basta selecionar a opção “<strong>Cancelar</strong>”.</p>
          <h4 id="resumo-do-ativo">Resumo do Ativo</h4>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_18.png" alt="" title="Aba principal do resumo"></p>
          <p>O <strong>Resumo do Ativo</strong> é uma ferramenta que permite visualizar as informações básicas de um
            ativo.
          </p>
          <p>É possível alterar a visualização das informações da tela de Resumo do Ativo em 6 (seis) abas diferentes,
            que são:
            Cotação, Gráfico, Variação, Delta, Volume e Outros.</p>
          <p>Por padrão, a plataforma exibe a aba “Cotação”. </p>
          <ul>
            <li><strong>Cotação</strong></li>
            <p><img src="assets/images/clients/{{broker}}/manual/IMG_18.png" alt="" title="Aba principal do resumo"></p>
            <p>Pela aba de cotação, é possível visualizar informações como: </p>
            <ul>
              <li>Máxima;</li>
              <li>Mínima;</li>
              <li>Abertura;</li>
              <li>Fechamento do dia anterior (Fech. Ant.);</li>
              <li>Preço de Melhor compra (P. Compra);</li>
              <li>Quantidade de compra (Qtd. Compra);</li>
              <li>Preço de Melhor venda (P. Venda);</li>
              <li>Quantidade de venda (Qtd. Venda).</li>
            </ul>
            <li>
              <p><strong>Gráfico</strong></p>
            </li>
            <p><img src="assets/images/clients/{{broker}}/manual/IMG_73.png" alt="" title="Gráfico do resumo"></p>
            <p>Pela aba de gráfico, é possível visualizar o gráfico de preço do ativo.</p>
            <li><strong>Variação</strong></li>
            <p><img src="assets/images/clients/{{broker}}/manual/IMG_74.png" alt="" title="Variação do resumo"></p>
            <p>Pela aba de variação, é possível visualizar informações como:</p>
            <ul>
              <li>Semanal;</li>
              <li>Mensal;</li>
              <li>Anual;</li>
              <li>1 Semana;</li>
              <li>1 Mensal;</li>
              <li>1 Ano.</li>
            </ul>
            <li><strong>Volume</strong></li>
            <p><img src="assets/images/clients/{{broker}}/manual/IMG_75.png" alt="" title="Volume do resumo"></p>
            <p>Pela aba de volume, é possível visualizar informações como:</p>
            <ul>
              <li>Quantidade;</li>
              <li>Volume ($);</li>
              <li>Volume (Q).</li>
            </ul>
            <li><strong>Delta</strong></li>
            <p><img src="assets/images/clients/{{broker}}/manual/IMG_76.png" alt="" title="Delta do resumo"></p>
            <p>Pela aba de delta, é possível visualizar informações como:</p>
            <ul>
              <li>Hora;</li>
              <li>Acumulada;</li>
              <li>Dia.</li>
            </ul>
            <li><strong>Outros</strong></li>
            <p><img src="assets/images/clients/{{broker}}/manual/IMG_77.png" alt="" title="Outros em resumo."></p>
            <p>Pela aba de outros, é possível visualizar informações como:</p>
            <ul>
              <li>Túnel Máximo (Túnel Max.);</li>
              <li>Túnel Mínimo (Túnel Mín.);</li>
              <li>Contrato Aberto (Cont. Aberto);</li>
              <li>Incremento de preço (Incre. Preço);</li>
              <li>Mercado;</li>
              <li>Forma de Cotação (Forma de C.);</li>
              <li>Lote Padrão;</li>
              <li>Multiplicador (Multiplicad.).</li>
            </ul>
          </ul>
          <h3 id="comprando-um-ativo">Comprando um ativo</h3>
          <p>Para realizar a compra de um ativo, selecione a opção “<strong>Comprar</strong>” e em seguida preencha a
            boleta
            com as informações necessárias.</p>
          <p>Lembre-se que ao selecionar a opção “<strong>Comprar</strong>”, a boleta é aberta com o preço referente ao
            “<strong>Melhor Preço de Venda</strong>” do momento.</p>
          <blockquote>
            <p><strong>Nota</strong>: As informações presentes na boleta serão detalhadas durante a explicação das
              informações de <strong>Negociação</strong>.</p>
          </blockquote>
          <h3 id="vendendo-um-ativo">Vendendo um ativo</h3>
          <p>Para realizar a venda de um ativo, selecione a opção “<strong>Vender</strong>” e em seguida preencha a
            boleta
            com as informações necessárias.</p>
          <p>Lembre-se que ao selecionar a opção “<strong>Vender</strong>”, a boleta é aberta com o preço referente ao
            “<strong>Melhor Preço de Compra</strong>” do momento.</p>
          <blockquote>
            <p><strong>Nota</strong>: As informações presentes na boleta serão detalhadas durante a explicação das
              informações de <strong>Negociação</strong>.</p>
          </blockquote>
          <h3 id="removendo-resumo-do-ativo-da-área-de-trabalho">Removendo resumo do ativo da área de trabalho</h3>
          <p>Para excluir o resumo do ativo da sua área de trabalho, você deve selecionar o ícone “<strong>X</strong>” e
            em
            seguida selecionar a opção “<strong>Confirmar</strong>”.</p>
          <p>Caso quisesse cancelar a ação, basta selecionar a opção “<strong>Cancelar</strong>”.</p>
          <h4 id="livro-de-ofertas">Livro de Ofertas</h4>
          <p>O <strong>Livro de Ofertas</strong> é uma ferramenta que permite a você acompanhar as melhores ofertas de
            compra e venda de um determinado ativo.</p>
          <h3 id="livro-de-ofertas-detalhado">Livro de ofertas detalhado</h3>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_22.png" alt="" title="Livro de ofertas Detalhado">
          </p>
          <p>Na visão do livro de ofertas <strong>detalhado</strong>, você terá acesso as seguintes informações:</p>
          <ul>
            <li>Símbolo do ativo;</li>
            <li>Nome da empresa;</li>
            <li>Preço;</li>
            <li>Taxa de variação;</li>
            <li>Valor máximo;</li>
            <li>Valor mínimo.</li>
          </ul>
          <p>Em relação as colunas, temos:</p>
          <ul>
            <li>Corretora (em relação aos preços de compra);</li>
            <li>Quantidade de compra;</li>
            <li>Melhor preço de compra;</li>
            <li>Melhor preço de venda;</li>
            <li>Quantidade de compra;</li>
            <li>Corretora (em relação aos preços de venda).</li>
          </ul>
          <h3 id="comprando-ou-vendendo-ativos-a-partir-do-livro-de-ofertas">Comprando ou vendendo ativos a partir do
            livro
            de ofertas</h3>
          <p>Para <strong>comprar</strong> um ativo com base no <strong>melhor preço de venda</strong>, selecione o
            preço
            do
            ativo pretendido na coluna “<strong>Venda</strong>” e preencha a boleta com as informações necessárias.</p>
          <p>Para <strong>vender</strong> um ativo com base no <strong>melhor preço de compra</strong>, selecione o
            preço
            do
            ativo pretendido na coluna “<strong>Compra</strong>” e preencha a boleta com as informações necessárias.</p>
          <blockquote>
            <p><strong>Nota</strong>: As informações presentes na boleta serão detalhadas durante a explicação das
              informações de <strong>Negociação</strong>.</p>
          </blockquote>
          <h3 id="livro-de-ofertas-agregado">Livro de ofertas agregado</h3>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_23.png" alt="" title="Livro de ofertas Agregado"></p>
          <p>Na visão do livro de ofertas <strong>agregado</strong>, você terá acesso as seguintes informações:</p>
          <ul>
            <li>Símbolo do ativo;</li>
            <li>Nome da empresa;</li>
            <li>Preço;</li>
            <li>Taxa de variação;</li>
            <li>Valor máximo;</li>
            <li>Valor mínimo.</li>
          </ul>
          <p>Em relação as colunas, temos:</p>
          <ul>
            <li>Quantidade de compra;</li>
            <li>Melhor preço de compra;</li>
            <li>Melhor preço de venda;</li>
            <li>Quantidade de compra;</li>
          </ul>
          <h3 id="livro-de-ofertas-escada">Livro de ofertas (Book Escada)</h3>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_79.png" alt="" title="Book escada"></p>
          <p>Na visão do livro de ofertas (Escada) você terá acesso as seguintes informações:</p>
          <ul>
            <li>Qtd. Compra (Quantidade de Compra);</li>
            <li>Preço;</li>
            <li>Qtd. Venda (Quantidade de Venda);</li>
          </ul>
          <blockquote>
            <p><strong>Nota:</strong>Vale destacar que na coluna "Preço" alguns valores serão exibidos em cores
              diferentes, onde
              cada um deles representa um significado, sendo eles:</p>
            <ul>
              <li>Amarelo: preço atual do ativo;</li>
              <li>Vermelho: mínima do dia;</li>
              <li>Verde: máxima do dia;</li>
              <li>Azul: abertura do dia</li>
            </ul>
          </blockquote>
          <h3 id="comprando-ou-vendendo-ativos-a-partir-do-livro-de-ofertas-1">Comprando ou vendendo ativos a partir do
            livro de ofertas</h3>
          <p>Para <strong>comprar</strong> um ativo com base no <strong>melhor preço de venda</strong>, selecione o
            preço
            do
            ativo pretendido na coluna “<strong>Venda</strong>” e preencha a boleta com as informações necessárias.</p>
          <p>Para <strong>vender</strong> um ativo com base no <strong>melhor preço de compra</strong>, selecione o
            preço
            do
            ativo pretendido na coluna “<strong>Compra</strong>” e preencha a boleta com as informações necessárias.</p>
          <blockquote>
            <p><strong>Nota</strong>: As informações presentes na boleta serão detalhadas durante a explicação das
              informações de <strong>Negociação</strong>.</p>
          </blockquote>
          <h3 id="removendo-livro-de-ofertas-da-área-de-trabalho">Removendo livro de ofertas da área de trabalho</h3>
          <p>Para excluir o livro de ofertas da sua área de trabalho, você deve selecionar o ícone “<strong>X</strong>”
            e
            em
            seguida selecionar a opção “<strong>Confirmar</strong>”.</p>
          <p>Caso quisesse cancelar a ação, basta selecionar a opção “<strong>Cancelar</strong>”.</p>
          <h4 id="negócios-realizados-times--trades">Negócios Realizados (Times &amp; Trades)</h4>
          <p>Negócios Realizados é uma ferramenta que permite visualizar todas as negociações ocorridas no dia para um
            determinado ativo.</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_24.png" alt="" title="Negócios Realizados"></p>
          <p>Na visão de negócios realizados, você terá acesso as seguintes informações:</p>
          <ul>
            <li>Símbolo do ativo;</li>
            <li>Nome da empresa;</li>
            <li>Preço;</li>
            <li>Taxa de variação;</li>
            <li>Valor máximo;</li>
            <li>Valor mínimo;</li>
            <li>Negócios.</li>
          </ul>
          <p>Em relação as colunas, temos:</p>
          <ul>
            <li>Horas;</li>
            <li>Preço;</li>
            <li>Quantidade;</li>
            <li>Comprador;</li>
            <li>Vendedor;</li>
            <li>Agressor.</li>
          </ul>
          <h3 id="removendo-negócios-realizados-da-área-de-trabalho">Removendo negócios realizados da área de trabalho
          </h3>
          <p>Para excluir o livro de ofertas da sua área de trabalho, você deve selecionar o ícone “<strong>X</strong>”
            e
            em
            seguida selecionar a opção “<strong>Confirmar</strong>”.</p>
          <p>Caso quisesse cancelar a ação, basta selecionar a opção “<strong>Cancelar</strong>”.</p>
          <h4 id="volume-por-preço-volume-at-price">Volume por Preço (Volume at Price)</h4>
          <p><strong>Volume por Preço</strong> é uma ferramenta que permite visualizar informações sobre o volume da
            negociação dos ativos com base no preço apresentado por cada um deles.</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_25.png" alt="" title="Volume no Preço"></p>
          <p>Na visão de <strong>volume por preço</strong>, você terá acesso as seguintes informações:</p>
          <ul>
            <li>Símbolo do ativo;</li>
            <li>Nome da empresa;</li>
            <li>Preço;</li>
            <li>Taxa de variação;</li>
            <li>Valor máximo;</li>
            <li>Valor mínimo;</li>
            <li>Horário da última atualização;</li>
            <li>Barra de volume (com base no período selecionado).</li>
          </ul>
          <blockquote>
            <p><strong>Nota</strong>: O preço atual do ativo será exibido com uma cor de destaque no campo
              “<strong>Preço</strong>”.</p>
          </blockquote>
          <p>Em relação aos períodos de tempos disponíveis e que podem ser alterados com base em sua preferência, temos:
          </p>
          <ul>
            <li><strong>DIA</strong>: Volume de negociação diária;</li>
            <li><strong>60M</strong>: Volume de negociação nos últimos 60 minutos;</li>
            <li><strong>30M</strong>: Volume de negociação nos últimos 30 minutos;</li>
            <li><strong>15M</strong>: Volume de negociação nos últimos 15 minutos;</li>
            <li><strong>10M</strong>: Volume de negociação nos últimos 10 minutos;</li>
            <li><strong>5M</strong>: Volume de negociação nos últimos 5 minutos;</li>
            <li><strong>1M</strong>: Volume de negociação nos últimos 1 minutos.</li>
          </ul>
          <blockquote>
            <p><strong>Nota</strong>: Por padrão, o Home Broker irá apresentar as informações com base no período
              “<strong>DIA</strong>”.</p>
          </blockquote>
          <p>Em relação as colunas, temos:</p>
          <ul>
            <li>Preço;</li>
            <li>Volume;</li>
            <li>Barra de volume;</li>
            <li>Saldo.</li>
          </ul>
          <h3 id="removendo-volume-por-preço-da-área-de-trabalho">Removendo volume por preço da área de trabalho</h3>
          <p>Para excluir o volume por preço da sua área de trabalho, você deve selecionar o ícone “<strong>X</strong>”
            e
            em
            seguida selecionar a opção “<strong>Confirmar</strong>”.</p>
          <p>Caso quisesse cancelar a ação, basta selecionar a opção “<strong>Cancelar</strong>”.</p>
          <h4 id="notícias">Notícias</h4>
          <p>Diferentemente das demais ferramentas citadas anteriormente, a tela de notícias pode ser acessada a partir
            do
            <strong>menu lateral</strong> do <strong>Home Broker</strong>.
          </p>
          <p>Nas notícias é possível acompanhar as principais notícias sobre o mercado financeiro, assim, você poderá
            ficar
            atualizado diretamente em nossa plataforma.</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_26.png" alt="" title="Lista de notícias"></p>
          <h3 id="exibindo-a-notícia-completa-eou-retornado-para-as-notícias-principais">Exibindo a notícia completa
            e/ou
            retornado para as notícias principais</h3>
          <p>Para exibir a notícia completa, selecione a opção “<strong>Saiba mais</strong>” ou simplesmente selecione o
            título da notícia.</p>
          <p>Uma vez que estiver visualizando uma notícia completa e deseja voltar para a tela das notícias principais,
            selecione a opção “<strong>Voltar</strong>”.</p>
          <h3 id="filtrando-as-notícias">Filtrando as notícias</h3>
          <p>Para pesquisar uma notícia pelo seu conteúdo ou pelo título, selecione o campo “<strong>pesquisar
              notícias</strong>” e insira o texto desejado. Em seguida, selecione a opção “<strong>Filtrar</strong>”.
          </p>
          <p>Para buscar uma notícia através de uma agência, selecione o campo “<strong>agência</strong>” e selecione
            umas
            das opções disponíveis, que são: <strong>Investimentos e Notícias</strong>, <strong>Cedro</strong>,
            <strong>Bovespa</strong>
            e <strong>BMF</strong>. Em seguida, selecione a opção “<strong>Filtrar</strong>”.
          </p>
          <p>Para buscar uma notícia dentro de um período específico, selecione uma <strong>data inicial</strong> e uma
            <strong>data final</strong> no campo “<strong>selecione um período desejado</strong>”. Em seguida, selecione
            a
            opção “<strong>Filtrar</strong>”.
          </p>
          <blockquote>
            <p><strong>Nota</strong>: É possível realizar uma busca utilizando todos os filtros disponíveis acima. Basta
              adicionar todos os parâmetros desejado e selecionar a opção “<strong>Filtrar</strong>” somente após
              preencher
              todos os filtros.</p>
          </blockquote>
          <h3 id="limpando-os-filtros">Limpando os filtros</h3>
          <p>Para apagar os parâmetros informados e voltar as notícias principais, selecione a opção
            “<strong>Limpar</strong>”.</p>
          <h3 id="alternando-visualização-nas-notícias">Alternando visualização nas notícias</h3>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_27.png" alt="" title="Grade de notícias"></p>
          <p>O <strong>Home Broker</strong>, por padrão, exibe as notícias no formato de <strong>lista</strong>. Caso
            deseje
            alternar para o formato de <strong>grade</strong>, como na imagem acima, você pode selecionar a opção <img
              src="assets/images/clients/{{broker}}/manual/IMG_28.png" alt="" title="Visualizando grade notícias">.
          </p>
          <p>Caso deseje visualizar novamente as notícias no formato de lista, selecione o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_28.png" alt="" title="Visualizando lista de notícias"> .
          </p>
          <h3 id="visualizar-notícias-através-da-ferramenta-da-área-de-trabalho">Visualizar notícias
            através
            da
            ferramenta da Área de Trabalho</h3>
          <p>Outra forma de visualizar as notícias no nosso Home Broker, é acessar a ferramenta de
            <strong>Notícias</strong>.
          </p>
          <p>É uma maneira rápida e prática de estar por dentro das principais notícias do mercado, sem
            precisar sair da sua área de trabalho, conforme apresentado na imagem abaixo.</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_55.png" alt="" title="Ferramenta de notícias"></p>
          <h4 id="maiores-do-dia">Maiores do Dia</h4>
          <p>Ferramenta acessada diretamente na área de trabalho, onde é possível visualizar os
            <strong>maiores
              ativos do dia</strong>, onde podem ser analisados em quatro tipos de abas diferentes.
          </p>
          <p>É possível alterar a visualização das informações em 4 abas diferentes, que são: Altas,
            Baixas, +Volume e -Volume.</p>
          <p>Por padrão, a plataforma exibe a aba “Altas”. </p>
          <p>As informações exibidas na ferramenta de Maiores do dia são: Posição (Pos.), Ativo, Preço,
            Variação (%) e Volume (R$).</p>
          <ul>
            <li>
              <p><strong>Altas</strong><br>
                <img src="assets/images/clients/{{broker}}/manual/IMG_59.png" alt="" title="Maiores Altas">
              </p>
            </li>
            <li>
              <p><strong>Baixas</strong><br>
                <img src="assets/images/clients/{{broker}}/manual/IMG_60.png" alt="" title="Maiores Baixas">
              </p>
            </li>
            <li>
              <p><strong>+ Volume</strong><br>
                <img src="assets/images/clients/{{broker}}/manual/IMG_61.png" alt="" title="Maiores Volumes (Positivo">
              </p>
            </li>
            <li>
              <p><strong>- Volume</strong><br>
                <img src="assets/images/clients/{{broker}}/manual/IMG_62.png" alt="" title="Maiores Volumes (Negativo">
              </p>
            </li>
          </ul>

          <h4 id="ativos-em-leilão">Ativos em Leilão</h4>
          <p>O leilão de ativos ocorre quando acontece um oscilação considerável no mercado.</p>
          <p>A bolsa utiliza esse mecanismo para combater a alta volatilidade do valor negociado para determinados
            ativos,
            assim, visando restabelecer o equilíbrio para novas negociações.
            Vale ressaltar que é um mecanismo que pode ser acionado várias vezes durante o pregão (caso necessário).</p>
          <p>Ativos em leilão serão representados da seguinte forma no seu Home Broker:</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_68.png" alt="" title="Ativos em leilão"></p>
          <blockquote>
            <p><strong>Nota:</strong> O símbolo de leilão poderá ser encontrado em vários componentes do Home Broker.
            </p>
          </blockquote>
          <h3 id="algumas-situações-onde-ocorrem-o-leilão-de-ativos">Algumas situações onde ocorrem o leilão de ativos
          </h3>
          <ul>
            <li>Quando ocorre uma oscilação (para mais ou para menos) a partir de 10% no preço de uma ação em com base
              ao preço de fechamento do dia anterior,
              antes da abertura do pregão atual;</li>
            <li>Quando ocorre uma oscilação (para mais ou para menos) a partir de 10% no preço de uma ação em relação ao
              preço de abertura do dia;</li>
            <li>Quando ocorre uma oscilação de preço entre 10% a 20% em relação ao último preço do papel antes de entrar
              em leilão.</li>
            <li>Leilões de pré-abertura e fechamento ocorrem para registrar ofertas de compra e venda que são realizadas
              antes
              do horário ou após o horário do pregão.</li>
          </ul>
          <p>O leilão tem como duração padrão 5 (cinco) minutos e caso seja necessário, pode estender por mais 5 (cinco)
            minutos.</p>

          <h4 id="negociação">Negociação</h4>
          <p>Quando citamos sobre <strong>Negociação</strong>, estamos nos referindo as informações que tangem ao envio
            de
            ordens, no caso, compra ou venda de ativos e toda a movimentação financeira que envolvem essa negociação de
            ações.</p>
          <p>Nota: Vale lembrar que para ter acesso as ferramentas de “Negociação”, você precisa possuir acesso de
            negociação, caso contrário, você será capaz de visualizar somente informações referente a Market Data.</p>
          <p>Vamos conhecer um pouco mais!</p>
          <h3 id="enviar-boleta-de-compra-ou-venda-simples">Enviar ordem (compra ou venda) a partir da Boleta Simples
          </h3>
          <p>A <strong>boleta</strong> é utilizada para que seja possível realizar o <strong>envio de ordens</strong>
            para
            o
            mercado.</p>
          <p>Na imagem abaixo, veja como é realizado o preenchimento de uma <strong>boleta simples</strong> (compra ou
            venda) para que seja possível enviá-la para o <strong>mercado</strong>, a fim de negociar o ativo em
            questão.
          </p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_30.png" alt="" title="Boleta Simples"></p>
          <p>Conheça mais sobre os campos que devem ser preenchidos em sua boleta simples para que ela esteja pronta
            para
            ser enviada ao mercado:</p>
          <ul>
            <li>
              <p><strong>Ativo</strong>: campo onde deve ser inserido o símbolo do ativo desejado à enviar ao mercado;
              </p>
            </li>
            <li>
              <p><strong>Conta</strong>: campo onde deve ser inserido o número da sua conta que está vinculado a
                corretora;
              </p>
            </li>
            <li>
              <p><strong>Precificação</strong>: campo onde deve ser inserido o tipo de precificação desejado na
                negociação,
                sendo as opções disponíveis:</p>
              <ul>
                <li>
                  <p><strong>Limitada</strong>: o investidor pode delimitar o preço para que a ordem seja executada;</p>
                </li>
                <li>
                  <p><strong>Mercado Limite</strong>: o investidor envia uma ordem com o preço estipulado pelo mercado e
                    caso a ordem não execute totalmente após a negociação percorrer todo o livro de ofertas com base no
                    preço estipulado pelo mercado, a ordem se torna uma ordem limitada, seguindo então o mesmo preço do
                    mercado.</p>
                </li>
              </ul>
            </li>
            <li>
              <p><strong>Duração</strong>: campo para informar o tempo da duração da negociação, sendo as opções
                disponíveis:</p>
              <ul>
                <li>
                  <p><strong>Hoje</strong>: a ordem é válida apenas para o dia atual;</p>
                </li>
                <li>
                  <p><strong>Até Cancelar (VAC)</strong>: a ordem é válida até ser cancelada;</p>
                </li>
                <li>
                  <p><strong>Até a Data</strong>: a ordem é válida até a data que deve ser definida no campo “Data do
                    vencimento”;</p>
                </li>
                <li>
                  <p><strong>Executa/Cancela</strong>: executa a quantidade disponível e o saldo restante é cancelado
                    pela
                    bolsa;</p>
                </li>
                <li>
                  <p><strong>Tudo/Nada</strong>: a ordem deverá ser totalmente executada, caso não seja, nada da ordem
                    deve
                    ser executada.</p>
                </li>
                <li>
                  <p><strong>No Fechamento</strong>: a ordem deverá ser enviada somente no horário de fechamento do
                    mercado;</p>
                </li>
                <li>
                  <p><strong>No Leilão</strong>: a ordem deverá ser enviada somente quando o ativo informado na boleta
                    estiver em leilão. </p>
                </li>
              </ul>
            </li>
            <li>
              <p><strong>Quantidade</strong>: campo para informar a quantidade a ser negociada;</p>
            </li>
            <li>
              <p><strong>Data de vencimento</strong>: campo para informar a data limite em que a ordem será válida;</p>
            </li>
            <li>
              <p><strong>Preço</strong>: campo para informar o preço unitário do ativo a ser negociado;</p>
            </li>
            <li>
              <p><strong>Operação</strong>: campo para informar qual estratégia que se deseja utilizar para a
                operação,
                sendo as opções disponíveis:</p>
              <ul>
                <li>
                  <p><strong>Position</strong>: operação onde o investidor pode permanecer posicionado por meses ou
                    até
                    anos;</p>
                </li>
                <li>
                  <p><strong>Daytrade</strong>: operação onde o investidor permanece posicionado por um curto período
                    de
                    tempo, podendo ser segundos, minutos ou algumas horas.</p>
                </li>
              </ul>
            </li>
          </ul>
          <p>Além dos campos, há informações relevantes a serem consideradas na boleta, como por exemplo:</p>
          <ul>
            <li>
              <p><strong>Último Negócio</strong>: campo para exibir o preço da última negociação do ativo;</p>
            </li>
            <li>
              <p><strong>Variação</strong>: campo para exibir a taxa de variação do preço do ativo;</p>
            </li>
            <li>
              <p><strong>Estado</strong>: campo para exibir o estado (status) atual do ativo no mercado;</p>
            </li>
            <li>
              <p><strong>Melhor compra</strong>: campo para exibir o preço da melhor oferta de compra do ativo;</p>
            </li>
            <li>
              <p><strong>Melhor venda</strong>: campo para exibir o preço da melhor oferta de venda do ativo;</p>
            </li>
            <li>
              <p><strong>Preço teórico</strong>: campo para exibir o preço de abertura do ativo;</p>
            </li>
            <li>
              <p><strong>Limite Operacional</strong>: campo para exibir qual o limite operacional disponível no momento
                para
                realizar a operação;</p>
            </li>
            <li>
              <p><strong>Total</strong>: campo para exibir o valor total de ações compradas, qual o ativo que está sendo
                negociado, o preço unitário do ativo e o valor total da operação.</p>
            </li>
          </ul>
          <p>Além dessas configurações acima, também existem campos que podem ou não ser preenchidos dentro de
            “<strong>opções avançadas</strong>”, sendo:</p>
          <ul>
            <li>
              <p><strong>Quantidade aparente</strong>: campo para definir a quantidade aparente da ordem de compra ou
                vendar
                à ser enviada ao mercado. Vale lembrar que essa ordem irá aparecer no Livro de Ofertas;</p>
            </li>
            <li>
              <p><strong>Quantidade mínima</strong>: campo para definir a quantidade mínima a ser negociada da ordem de
                compra ou venda.</p>
            </li>
          </ul>
          <p>E outras informações como:</p>
          <ul>
            <li>
              <p><strong>Túnel Máximo</strong>: valor máximo que a bolsa estabelece para que o ativo seja negociado.</p>
            </li>
            <li>
              <p><strong>Túnel Mínimo</strong>: valor mínimo que a bolsa estabelece para que o ativo seja negociado.</p>
            </li>
          </ul>
          <p>Além disso, no cabeçalho, você poderá alterar entre as boletas
            <strong>Simples</strong>,<strong>Rápida</strong> e
            <strong>DOM</strong>, conforme exibido na imagem abaixo.
          </p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_83.png" alt="" title="Cabeçalho boleta"></p>
          <p>Após preencher todos os parâmetros citados, para finalizar sua operação, basta selecionar a opção
            “<strong>Comprar</strong>” ou “<strong>Vender</strong>”, dependendo da operação que estiver realizando.</p>

          <h3 *ngIf="showDoubleAuthEletronicSignature" id="confirmar-operação-com-assinatura-eletrônica">Confirmar
            operação com assinatura
            eletrônica</h3>
          <p *ngIf="showDoubleAuthEletronicSignature">Na tela de confirmação da operação na boleta, você deve informar
            sua assinatura
            eletrônica (composta por 6
            dígitos numéricos) para finalizar a operação.</p>
          <p *ngIf="showDoubleAuthEletronicSignature">É possível gravar a assinatura para que você não precisa
            informá-la novamente em sua
            próxima operação,
            conforme
            pode ser visualizado na imagem abaixo.</p>
          <p *ngIf="showDoubleAuthEletronicSignature"><img src="assets/images/clients/{{broker}}/manual/IMG_53.png"
              alt="" title="Assinatura eletrônica na operação">
          </p>
          <blockquote *ngIf="showDoubleAuthEletronicSignature">
            <p><strong>Nota</strong>: Caso você logado com um usuário de <strong>Assessor</strong>, não é necessário
              informar
              uma assinatura eletrônica para confirmar o envio de uma ordem ao mercado.</p>
          </blockquote>
          <p *ngIf="showDoubleAuthEletronicSignature">Vale lembrar que o mesmo comportamento ocorre durante suas
            operações realizadas na
            Boleta Stop e também nos
            componentes de boleta na área de trabalho (Boleta e Boleta Rápida).</p>
          <h3 *ngIf="showSuitability" id="assinando-termo-de-desenquadramento">Assinando termo de desenquadramento</h3>
          <p>Caso você não esteja apto a negociar um determinado ativo, devido ao seu perfil do
            investidor, você pode
            assinar
            o <strong>Termo de Desenquadramento</strong>, garantido que você está ciente dos riscos ao finalizar a
            operação.
          </p>
          <p *ngIf="showSuitability"><img src="assets/images/clients/{{broker}}/manual/IMG_52.png" alt=""
              title="Termo de desenquadramento"></p>
          <p *ngIf="showSuitability">Após assinado, selecione a opção “<strong>Confirmar</strong>” .</p>
          <p>Caso a operação seja efetuada com sucesso, você deverá visualizar a mensagem
            “<strong>Ordem recebida com
              sucesso</strong>”.</p>
          <blockquote>
            <p><strong>Nota</strong>: Vale lembrar que os parâmetros a serem ajustados em ambas as boletas
              (<strong>Compra</strong> ou <strong>Venda</strong>) são os mesmos.</p>
            <p *ngIf="showSuitability">Além disso, caso você possua o perfil de suitability permitido para negociar um
              determinado ativo, não
              será
              exibido à você o <strong>Termo de Desenquadramento</strong>.</p>
          </blockquote>
          <p>Vale lembrar que o mesmo comportamento ocorre durante suas operações realizadas na
            Boleta Stop e também nos
            componentes de boleta na área de trabalho (Boleta e Boleta Rápida).</p>

          <p>Caso a operação seja efetuada com sucesso, você deverá visualizar a mensagem
            “<strong>Ordem recebida com sucesso</strong>”.</p>
          <blockquote *ngIf="showSuitability">
            <p><strong>Nota</strong>: Vale lembrar que os parâmetros a serem ajustando em ambas as boletas
              (<strong>Compra</strong> ou <strong>Venda</strong>) são os mesmos.</p>
          </blockquote>
          <h3 id="enviar-boleta-de-compra-ou-venda-stop">Enviar ordem (compra ou venda) a partir da Boleta Stop</h3>
          <p>A <strong>boleta</strong> é utilizada para que seja possível realizar o <strong>envio de ordens</strong>
            para
            o
            mercado.</p>
          <p>A diferença entre a <strong>boleta simples</strong> (detalhada anteriormente) para uma <strong>boleta
              stop</strong> é que na boleta stop, é possível informar um valor para que a sua ordem seja disparada ao
            mercado, sendo assim, esse valor será comparado ao valor do último negócio do ativo.</p>
          <p>No momento em que a cotação do ativo atingir o preço informado no <strong>preço de disparo</strong>
            (conhecido
            também como <strong>gatilho</strong>), então será enviada uma ordem limitada ao mercado com base no preço
            informado.</p>
          <p>A <strong>boleta stop</strong> pode ser enviada de três maneiras:</p>
          <ul>
            <li>
              <p><strong>Stop Loss</strong>: uma ordem ajustada para ser dispara automaticamente ao mercado, caso o
                ativo
                atinja o valor de perda inserida pelo investidor, neste caso, servindo para ajudar a minimizar suas
                perdas;
              </p>
            </li>
            <li>
              <p><strong>Stop Gain</strong>: uma ordem ajustada para ser dispara automaticamente ao mercado, caso o
                ativo
                atinja o valor de ganho inserido pelo investidor, neste caso, servindo para ajudar a maximizar seus
                lucros;
              </p>
            </li>
            <li>
              <p><strong>Stop Simultâneo</strong>: boleta onde é possível definir o preço de gain (lucro) e o preço de
                loss
                (prejuízo) de uma única vez.</p>
            </li>
          </ul>
          <p>Abaixo veja como devem ser preenchidas as informações para que seja possível enviar uma <strong>boleta
              stop</strong> ao mercado:<br>
            <img src="assets/images/clients/{{broker}}/manual/IMG_31.png" alt="" title="Boleta Stop">
          </p>
          <p>Para ativar uma boleta stop, selecione a opção “<strong>Stop</strong>” na parte superior de uma boleta.</p>
          <p>Caso deseje operar utilizando apenas a boleta <strong>Stop Loss</strong>, habilite o botão para ação,
            conforme
            apresentado na imagem abaixo:</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_32.png" alt="" title="Stop Loss"></p>
          <p>Caso deseje operar utilizando apenas a boleta <strong>Stop Gain</strong>, habilite o botão para ação,
            conforme
            apresentado na imagem abaixo:</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_33.png" alt="" title="Stop Gain"></p>
          <p>Caso deseje operar utilizando a boleta <strong>Stop Simultâneo</strong>, habilite ambos os botões para
            ação,
            conforme apresentado na imagem abaixo:</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_34.png" alt="" title="Stop Simultâneo"></p>
          <p>As informações que devem ser preenchidas antes de realizar o envio de uma <strong>boleta stop</strong> são:
          </p>
          <ul>
            <li>
              <p><strong>Preço de disparo (Stop Loss)</strong>: campo para definir o preço de gatilho de perda da ordem
                a
                ser enviada;</p>
            </li>
            <li>
              <p><strong>Preço de limite (Stop Loss)</strong>: campo para definir o preço que a ordem será executada ao
                atingir o preço de disparo de perda definido;</p>
            </li>
            <li>
              <p><strong>Preço de disparo (Stop Gain)</strong>: campo para definir o preço do gatilho de ganho da ordem
                a
                ser enviada;</p>
            </li>
            <li>
              <p><strong>Preço de limite (Stop Gain)</strong>: campo para definir o preço que a ordem será executada ao
                atingir o preço de disparo de ganho da ordem a ser enviada.</p>
            </li>
          </ul>
          <p>Após preencher todos os parâmetros citados, para finalizar sua operação, basta selecionar a opção
            “<strong>Comprar</strong>” ou “<strong>Vender</strong>”, dependendo da operação que estiver realizando.</p>
          <p>Caso a operação seja efetuada com sucesso, você deverá visualizar a mensagem “<strong>Ordem recebida com
              sucesso</strong>”.</p>
          <blockquote>
            <p><strong>Nota</strong>: Os demais itens presentes na boleta seguem o mesmo padrão encontrado na
              <strong>boleta
                simples</strong>, a exceção do campo “<strong>Precificação</strong>”, sendo que na boleta stop toda
              ordem
              tem a característica de ser <strong>Limitada</strong>.
            </p>
          </blockquote>
          <h3 id="enviar-boleta-de-compra-ou-venda-dom">Enviar ordem (compra ou venda) a partir da Boleta DOM</h3>
          <p>A <strong>Boleta DOM</strong> é uma ferramenta que permitirá que você envie ordens ao mercado a partir do
            Book Escada,
            uma variação do nosso Livro de Ofertas, que irá permitir que você visualize algumas colunas, contendo as
            informações de <strong>Quantidade comprada (compra)</strong><strong>Quantidade de Compra</strong>,
            <strong>Preço</strong>,<strong>Quantidade de
              Venda</strong> e <strong>Quantidade comprada (venda)</strong> para
            o ativo informado na boleta.
          </p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_84.png" alt="" title="Boleta DOM"></p>
          <p>Assim como é visto na Boleta Rápida, na Boleta DOM, você terá acesso a alguns botões para facilitar sua
            operação, sendo eles:</p>
          <ul>
            <li>
              <p>C.Mercado (Compra à mercado);</p>
              <p>Comprar;</p>
              <p>Zerar;</p>
              <p>Canc. Todas (Cancelar todas);</p>
              <p>V. Mercado (Venda à mercado);</p>
              <p>Vender;</p>
          </ul>

          <p>Na coluna Preço do Book Escada, você poderá visualizar diferentes informações, que serão representadas nas
            respectivas cores:
          </p>
          <ul>
            <li>
              <p><strong>Preço atual do ativo</strong>: representado na cor amarela;</p>
            </li>
            <li>
              <p><strong>Mínima do dia:</strong>: representado na cor vermelha;</p>
            </li>
            <li>
              <p><strong>Máxima do dia:</strong>: representado na cor verde;</p>
            </li>
            <li>
              <p><strong>Abertura do dia:</strong>: representado na cor azul.</p>
            </li>
          </ul>
          <p>Nesta boleta, as configurações a serem preenchidas são somente o código o ativo e a quantidade, tudo com o
            intuito de você
            conseguir enviá-la mais rapidamente sua ordem, além de ser capaz de zerar ou reverter a sua posição para o
            ativo. </p>
          <p>Além disso,há uma opção que pode ser visualizada no cabeçalho da ordem (que pode ser visualizada na imagem
            abaixo),
            a função "Centralizar/Descentralizar Preço", que ao ser habilitada
            faz com que Book presente na boleta sempre mantenha o preço atual do ativo de forma centralizada. Para
            desabilitar a função,
            basta selecionar novamente na opção. </p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_85.png" alt=""
              title="Centralizar/Descentralizar Preço"></p>

          <h3 id="utilizando-ferramenta-de-boleta-na-área-de-trabalho">Utilizando ferramenta de Boleta na
            Área
            de Trabalho</h3>
          <p>Você também pode realizar o envio de uma ordem ao mercado utilizando a ferramenta da
            <strong>boleta</strong> adicionada a sua área de trabalho, conforme apresentado na imagem abaixo.
          </p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_19.png" alt="" title="Ferramenta de Boleta">
          </p>
          <p>Além disso, ao selecionar a aba <strong>Stop</strong>, é possível realizar o envio de uma
            Boleta
            Stop, conforme a imagem abaixo.</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_20.png" alt="" title="Ferramenta de Boleta Stop"></p>
          <p>As configurações à serem preenchidas são as mesmas presentes na seção anterior.</p>
          <p>Após preencher todos os parâmetros citados, para finalizar sua operação, basta selecionar a
            opção
            “<strong>Comprar</strong>” ou “<strong>Vender</strong>”, dependendo da operação que estiver realizando, além
            de
            informar sua assinatura eletrônica, caso necessário, se não, apenas confirme a opção na opção
            “<strong>Confirmar</strong>”.</p>
          <p>Caso a operação seja efetuada com sucesso, você deverá visualizar a mensagem “<strong>Ordem
              enviada com sucesso</strong>”.</p>
          <h3 id="utilizando-ferramenta-de-boleta-rápida-na-área-de-trabalho">Utilizando ferramenta de
            Boleta
            Rápida na Área de Trabalho</h3>
          <p>Uma maneira, rápida e prática de enviar uma ordem ao mercado, é utilizar a ferramenta de
            <strong>Boleta Rápida</strong>, que pode ser acessada exclusivamente a partir da área de trabalho.
          </p>
          <p>Nesta boleta, as configurações á serem preenchidas são somente o código o ativo e a
            quantidade,
            tudo com o intuito de você conseguir envia-lá mais rapidamente sua ordem.</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_21.png" alt="" title="Ferramenta de Boleta Rápida">
          </p>
          <p>As informações que podem ser encontradas na boleta rápida são:</p>
          <ul>
            <li>
              <p><strong>Ativo</strong>: campo onde deve ser inserido o símbolo do ativo desejado à enviar ao mercado;
              </p>
            </li>
            <li>
              <p><strong>Último Negócio</strong>: campo para exibir o preço da última negociação do ativo;</p>
            </li>
            <li>
              <p><strong>Variação</strong>: campo para exibir a taxa de variação do preço do ativo;</p>
            </li>
            <li>
              <p><strong>Posição</strong>: campo para exibir se o usuário está ou não posicionado determinado ativo;</p>
            </li>
            <li>
              <p><strong>Médio (Preço Médio)</strong>: campo para exibir o valor do preço médio;</p>
            </li>
            <li>
              <p><strong>L/P Aberto</strong>: campo para exibir o lucro ou prejuízo aberto do dia do usuário no
                determinado
                ativo;</p>
            </li>
            <li>
              <p><strong>L/P Fechado</strong>: campo para exibir o lucro ou prejuízo fechado do dia do usuário no
                determinado ativo;</p>
            </li>
            <li>
              <p><strong>Livro de ofertas</strong>: aba para exibir o livro de ofertas do determinado ativo;</p>
            </li>
            <li>
              <p><strong>Quantidade</strong>: campo para informar a quantidade a ser negociada;</p>
            </li>
            <li>
              <p><strong>Zerar</strong>: opção para encerrar a posição do dia do usuário para o determinado ativo;</p>
            </li>
            <li>
              <p><strong>Reverter</strong>: opção para reverter a posição do dia do usuário para o determinado ativo;
              </p>
            </li>
          </ul>
          <p>Após preencher todos os parâmetros citados, para finalizar sua operação, basta selecionar a
            opção
            “<strong>Comprar</strong>” ou “<strong>Vender</strong>”, dependendo da operação que estiver realizando, além
            de
            informar sua assinatura eletrônica, caso necessário, se não, apenas confirme a opção na opção
            “<strong>Confirmar</strong>”.</p>
          <p>Caso a operação seja efetuada com sucesso, você deverá visualizar a mensagem “<strong>Ordem
              enviada com sucesso</strong>”.</p>
          <h3 id="consultando-as-informações-do-financeiro">Consultando as informações do Patrimônio</h3>
          <p>Na tela de <strong>Patrimônio</strong>, acessada pelo menu lateral do <strong>Home
              Broker</strong>, é o lugar onde o investidor poderá consultar seu saldo e todas as informações financeiras
            possíveis, visualizando o quanto já foi investido, quanto você tem disponível, consultar seu patrimônio,
            limites, alavancagens, entre outras informações;</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_35.png" alt="" title="Patrimônio"></p>
          <h4 id="informações-apresentadas-no-financeiro">Informações apresentadas no Patrimônio</h4>
          <p>As informações que podem ser consultadas na tela de <strong>Patrimônio</strong> são apresentadas da
            seguinte
            maneira:</p>
          <ul>
            <li>
              <p><strong>Saldo em conta</strong>:</p>
              <ul>
                <li>Saldo em conta;</li>
                <li>Saldo projetado;</li>
              </ul>
            </li>
            <li>
              <p><strong>Ajuste BMF</strong>:</p>
              <ul>
                <li>Ajuste posição;</li>
                <li>Ajuste pregão;</li>
              </ul>
            </li>
            <li>
              <p><strong>Posição</strong>:</p>
              <ul>
                <li>Custódia online;</li>
                <li>Proventos;</li>
                <li>Garantia;</li>
                <li>Garantia livre;</li>
                <li>Renda Fixa;</li>
                <li>Fundos;</li>
                <li>Clubes;</li>
                <li>Tesouro Direto;</li>
              </ul>
            </li>
            <li>
              <p><strong>Lucro/Prejuízo Day Trade</strong>:</p>
              <ul>
                <li>L/P Aberto (Lucro/Prejuízo Aberto);</li>
                <li>L/P Fechado (Lucro/Prejuízo Fechado);</li>
                <li>L/P Total (Lucro/Prejuízo Total);</li>
              </ul>
            </li>
            <li>
              <p><strong>Patrimônio</strong>:</p>
              <ul>
                <li>Patrimônio inicial;</li>
                <li>Patrimônio online;</li>
              </ul>
            </li>
            <li>
              <p><strong>Limites</strong>:</p>
              <ul>
                <li>Limite operacional;</li>
                <li>Alavancagem à vista;</li>
                <li>Alavancagem opções;</li>
                <li>Alavancagem futuro;</li>
              </ul>
            </li>
          </ul>
          <h4 id="ocultando-os-valores-da-tela-de-financeiro">Ocultando os valores da tela de Patrimônio</h4>
          <p>Para ocultar os valores da tela de Patrimônio, selecione o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_36.png" alt="" title="Ocultar valores"> da opção
            “<strong>Esconder valores</strong>”.</p>
          <p>O resultado é apresentado na imagem abaixo:</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_37.png" alt=""
              title="Patrimônio com valores ocultados"> </p>
          <p>Caso deseje reexibir os valores, selecione o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_38.png" alt="" title="Exibir valores"> da opção
            “<strong>Mostrar valores</strong>”.</p>
          <h3 id="realizando-a-consulta-de-ordens">Realizando a consulta de ordens</h3>
          <p>Na tela de <strong>Ordens</strong>, acessada a partir do menu lateral do <strong>Home Broker</strong>, o
            investidor poderá acompanhar suas ordens enviadas ao mercado no dia atual ou consultando um histórico com o
            envio de suas ordens com base no tempo informado.</p>
          <h4 id="ordens-do-dia">Ordens do dia</h4>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_39.png" alt="" title="Ordens do dia"></p>
          <p>Em <strong>Ordens do dia</strong>, será possível visualizar todas as informações referentes a cada uma das
            ordens que foram enviadas no dia atual, sendo que elas poderão ser filtradas utilizando os parâmetros de sua
            preferência.</p>
          <h5 id="colunas-disponíveis">Colunas disponíveis</h5>
          <p>A colunas que lhe apresentarão as informações sobre suas ordens são:</p>
          <ul>
            <li>
              <p><strong>Status</strong>: exibe qual o status da ordem, tendo como opção ordens definidas como abertas,
                executadas, canceladas, rejeitadas ou expiradas;</p>
            </li>
            <li>
              <p><strong>Ativo</strong>: exibe o símbolo do ativo;</p>
            </li>
            <li>
              <p><strong>Tipo</strong>: exibe o tipo de precificação da ordem, tendo como opção ordens do tipo limitada,
                mercado com proteção, mercado limite e stop;</p>
            </li>
            <li>
              <p><strong>Direção</strong>: exibe a direção em que a ordem foi enviada, ou seja, exibe se foi uma ordem
                de
                compra ou uma ordem de venda;</p>
            </li>
            <li>
              <p><strong>Quantidade ofertada (Qtd.)</strong>: exibe a quantidade ofertada na ordem que foi enviada ao
                mercado;</p>
            </li>
            <li>
              <p><strong>Quantidade executada (Exec.)</strong>: exibe a quantidade que foi executada da ordem;</p>
            </li>
            <li>
              <p><strong>Restante</strong>: exibe a quantidade restante da ordem a ser executada, ou seja, quantidade
                disponível;</p>
            </li>
            <li>
              <p><strong>Preço</strong>: exibe o preço ofertado pelo ativo da ordem enviada;</p>
            </li>
            <li>
              <p><strong>Preço médio</strong>: exibe o preço médio do ativo da ordem enviada;</p>
            </li>
            <li>
              <p><strong>Mercado</strong>: exibe de qual mercado o ativo é pertencente, podendo ser BM&amp;F ou Bovespa;
              </p>
            </li>
            <li>
              <p><strong>Data/Hora</strong>: exibe a data e hora de criação ou atualização da ordem.</p>
            </li>
          </ul>
          <h5 id="filtros-disponíveis">Filtros disponíveis</h5>
          <p>Em relação aos filtros disponíveis e quanto a forma de utilização de cada um deles, temos:</p>
          <ul>
            <li>
              <p>Caso deseje filtrar suas ordens por status, selecione a opção “<strong>status</strong>”, selecione uma
                das
                opções abaixo e depois selecione o botão “<strong>Filtrar</strong>”:</p>
              <ul>
                <li>Todas;</li>
                <li>Abertas;</li>
                <li>Executadas;</li>
                <li>Canceladas;</li>
                <li>Rejeitadas;</li>
                <li>Expirada.</li>
              </ul>
            </li>
            <li>
              <p>Caso deseje filtrar suas ordens com base no tipo da ordem, selecione a opção “<strong>tipo</strong>”,
                selecione uma das opções abaixo e depois selecione o botão “<strong>Filtrar</strong>”:</p>
              <ul>
                <li>Todas;</li>
                <li>Limitada;</li>
                <li>Mercado com proteção;</li>
                <li>Mercado limite;</li>
                <li>Stop.</li>
              </ul>
            </li>
            <li>
              <p>Caso deseje filtrar suas ordens por direção, selecione a opção “<strong>direção</strong>”, selecione
                uma
                das opções abaixo e depois selecione o botão “<strong>Filtrar</strong>”:</p>
              <ul>
                <li>Todas;</li>
                <li>Compra;</li>
                <li>Venda.</li>
              </ul>
            </li>
            <li>
              <p>Caso deseje filtrar suas ordens por mercado, selecione a opção “<strong>mercado</strong>”, selecione
                uma
                das opções abaixo e depois selecione o botão “<strong>Filtrar</strong>”:</p>
              <ul>
                <li>Todos;</li>
                <li>Bovespa;</li>
                <li>BM&amp;F.</li>
              </ul>
            </li>
            <li>
              <p>Caso deseje filtrar suas ordens por ativo, selecione o campo “<strong>ativo</strong>”, insira o símbolo
                do
                ativo desejado e depois selecione o botão “<strong>Filtrar</strong>”.</p>
            </li>
            <li></li>
          </ul>
          <blockquote>
            <p><strong>Nota</strong>: É possível realizar uma busca utilizando todos os filtros disponíveis acima. Basta
              adicionar todos os parâmetros desejado e selecionar a opção “<strong>Filtrar</strong>” somente após
              preencher
              todos os filtros.</p>
          </blockquote>
          <h5 id="limpando-os-filtros-1">Limpando os filtros</h5>
          <p>Para apagar os parâmetros informados, selecione a opção “<strong>Limpar</strong>”.</p>
          <h3 id="histórico-geral-de-ordens">Histórico geral de ordens</h3>
          <p>Para acessar o histórico geral de ordens, selecione a aba “<strong>Histórico geral</strong>” na tela de
            <strong>Consulta de Ordens</strong>, conforme exibido na imagem abaixo:
          </p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_40.png" alt="" title="Histórico geral de ordens"></p>
          <p>No <strong>Histórico geral</strong> é possível visualizar as ordens que foram enviadas dentro do período
            informado pelo investidor.</p>
          <h3 id="colunas-disponíveis-1">Colunas disponíveis</h3>
          <p>As colunas disponíveis são as mesmas que podem ser visualizadas na tela de <strong>Ordens do dia</strong>,
            sendo assim, você pode visualizá-las no <strong>tópico anterior</strong>.</p>
          <h3 id="filtros-disponíveis-1">Filtros disponíveis</h3>
          <p>Os filtros disponíveis são os mesmos presentes na tela de <strong>Ordens do dia</strong>, sendo assim, com
            exceção ao campo “<strong>selecione o período desejado</strong>” descrito logo abaixo:</p>
          <ul>
            <li>Para filtrar as ordens com base em um período específico, selecione uma <strong>data inicial</strong> e
              uma
              <strong>data final</strong> no campo “<strong>selecione o período desejado</strong>”, e em seguida,
              selecione
              a opção “<strong>Filtrar</strong>”.
            </li>
          </ul>
          <blockquote>
            <p><strong>Nota</strong>: É possível realizar uma busca utilizando todos os filtros disponíveis acima. Basta
              adicionar todos os parâmetros desejado e selecionar a opção “<strong>Filtrar</strong>” somente após
              preencher
              todos os filtros.</p>
          </blockquote>
          <h3 id="limpando-os-filtros-2">Limpando os filtros</h3>
          <p>Para apagar os parâmetros informados, selecione a opção “<strong>Limpar</strong>”.</p>
          <h4 id="visualizando-detalhes-das-ordens">Visualizando detalhes das ordens</h4>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_41.png" alt="" title="Detalhes da ordem"></p>
          <p>Para visualizar os <strong>detalhes</strong> da ordem, selecione o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_42.png" alt="" title="Abrir detalhes"> ao lado do status
            da
            ordem.</p>
          <p>Feito isso, novas informações serão exibidas, como por exemplo:</p>
          <ul>
            <li>ID da ordem;</li>
            <li>Operação;</li>
            <li>Validade;</li>
            <li>Quantidade Aparente (Qtd. Apararente);</li>
            <li>Quantidade Mínima (Qtd. Mínima);</li>
            <li>Preço de disparo de ganho (P. de disp. de ganho);</li>
            <li>Preço de disparo de perda (P. de disp. de perda);</li>
            <li>Preço de limite de ganho (P. de limite de ganho);</li>
            <li>Preço de limite de perda (P. de limite de perda);</li>
            <li>Motivo da rejeição.</li>
          </ul>
          <p>Além dessas informações, é possível acompanhar um histórico de atualização diária do status da ordem,
            apresentando informações como:</p>
          <ul>
            <li>Status;</li>
            <li>Quantidade Executada (Exec.);</li>
            <li>Restante;</li>
            <li>Data e Hora.</li>
          </ul>
          <h4 id="reenviando-ordens">Reenviando ordens</h4>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_43.png" alt="" title="Reenvio de ordens"></p>
          <p>Para <strong>reenviar</strong> uma ordem ao mercado, selecione o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_44.png" alt="" title="Ícone de reenvio de ordens">
            e
            em seguida selecione o botão “<strong>Confirmar</strong>” para reenviar sua ordem ou
            “<strong>Cancelar</strong>”
            caso desista de realizar a operação.</p>
          <p>O <strong>reenvio de ordens</strong> pode ser feito somente com ordens que apresentam os seguintes status:
          </p>
          <ul>
            <li>Executada;</li>
            <li>Cancelada;</li>
            <li>Rejeitada;</li>
            <li>Suspensa;</li>
            <li>Expirada.</li>
          </ul>
          <p>Caso a ordem seja reenviada com sucesso, será exibida a seguinte mensagem “<strong>Ordem recebida com
              sucesso</strong>”.</p>
          <h4 id="editando-ordens">Editando ordens</h4>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_43.png" alt="" title="Editando ordens"></p>
          <p>Para <strong>editar</strong> uma ordem, selecione o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_45.png" alt="" title="Ícone de edição de ordens">
            .
          </p>
          <p>Em seguida, será exibida uma <strong>boleta</strong>, onde você poderá editar os parâmetros que foram
            inseridos
            anteriormente em sua boleta, conforme a imagem abaixo:</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_46.png" alt="" title="Edição de ordens"></p>
          <p>A <strong>edição de ordens</strong> pode ser feito somente com ordens que apresentam os seguintes status:
          </p>
          <ul>
            <li>Nova;</li>
            <li>Parcialmente Executada;</li>
            <li>Pendente.</li>
          </ul>
          <p>Após ajustados os parâmetros, selecione a opção “<strong>Salvar</strong>” e em seguida selecione a opção
            “<strong>Confirmar</strong>” para atualizar sua ordem ou a opção “<strong>Cancelar</strong>” caso desista de
            realizar a operação.</p>
          <h4 id="cancelando-ordens">Cancelando ordens</h4>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_43.png" alt="" title="Cancelar/remover ordens"></p>
          <p>Para realizar o <strong>cancelamento de envio</strong> de uma ordem ao mercado, selecione o ícone <img
              src="assets/images/clients/{{broker}}/manual/IMG_47.png" alt="" title="Ícone de cancelamento de ordens"> .
          </p>
          <p>O <strong>cancelamento de ordens</strong> pode ser feito somente com ordens que apresentam os seguintes
            status:
          </p>
          <ul>
            <li>Nova;</li>
            <li>Parcialmente executada;</li>
            <li>Pendente.</li>
          </ul>
          <p>Caso a ordem seja cancelada com sucesso, será exibida a seguinte mensagem “<strong>Ordem Cancelada com
              sucesso</strong>”.</p>
          <h4 id="visualizar-ordens-através-da-área-de-trabalho">Visualizar Ordens através da Área de
            Trabalho
          </h4>
          <p>É possível visualizar suas ordens enviadas ao mercado no dia atual através da ferramenta de
            <strong>Ordens</strong>, que pode ser acessada diretamente na sua área de trabalho.
          </p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_57.png" alt="" title="Ferramenta de Ordens">
          </p>
          <p>Você pode poder realizar edição, cancelamento e reenvio de ordens (caso seja aplicável para a
            ordem em questão) através do ícone <img src="assets/images/clients/{{broker}}/manual/IMG_51.png" alt=""
              title="Ícone de edição, cancelamento ou reenvio de ordens">, onde ocorrerá o mesmo processo
            descrito
            nas
            seções anteriores para cada uma dessas funcionalidades.</p>
          <h3 id="consulta-de-custódia">Consulta de custódia</h3>
          <p>Na <strong>consulta de custódia</strong>, acessada pelo menu lateral do <strong>Home Broker</strong>, o
            investidor terá uma visão de como está sua carteira de ativos e poderá acompanhar todas as informações sobre
            esses investimentos e consultar os seus proventos.</p>
          <p>Tanto para consulta de custódia de BMF, quanto para consulta de Bovespa, você poderá alterar entre sua
            posição em períodos diferentes.</p>
          <p>As opções disponíveis são:</p>
          <ul>
            <li>Posição atual;</li>
            <li>Posição do dia;</li>
            <li>Posição histórica.</li>
          </ul>
          <h4 id="custódia-bovespa">Custódia Bovespa</h4>
          <p>Na aba “<strong>Bovespa</strong>” na tela de Consulta de custódia, você poderá ver todas as informações
            referentes aos ativos adquiridos no mercado Bovespa da Bolsa de Valores.</p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_48.png" alt="" title="Custódia Bovespa"></p>
          <h5 id="colunas-disponíveis-2">Colunas disponíveis</h5>
          <p>As <strong>colunas</strong> disponíveis na aba de <strong>Consulta Bovespa</strong>, apresentam as
            seguintes
            informações:</p>
          <ul>
            <li>Ativo;</li>
            <li>Tipo;</li>
            <li>Quantidade Inicial (Q. Inicial);</li>
            <li>Quantidade Atual (Q. Atual);</li>
            <li>Preço Atual (P. Atual);</li>
            <li>Preço Fechamento (P. Fech.);</li>
            <li>Valor Inicial;</li>
            <li>Valor Atual;</li>
            <li>Quantidade Executada de Compra (Q. Exec. Compra);</li>
            <li>Quantidade Executada de Venda (Q. Exec. Venda).</li>
          </ul>
          <h5 id="filtros-disponíveis-2">Filtros disponíveis</h5>
          <p>Os filtros disponíveis na aba de <strong>Consulta Bovespa</strong> são:</p>
          <ul>
            <li><strong>Ativo</strong>: campo para buscar pelo símbolo do ativo e para aplicar o filtro, selecione a
              opção
              “<strong>Filtrar</strong>”;</li>
            <li><strong>Exibir posição do dia</strong>: ação para exibir qual a posição do investidor diária em relação
              a
              cada ativo. As colunas exibidas após a seleção do filtro “exibir posição do dia” são alteradas, sendo
              apresentadas da seguinte maneira:
              <ul>
                <li>Ativo;</li>
                <li>Tipo;</li>
                <li>Compra Executada no Dia (Compra Exec. Dia);</li>
                <li>Venda Executada no Dia (Venda Exec. Dia);</li>
                <li>NET no dia (NET Dia);</li>
                <li>Preço médio aberto (Pr. Med. Aberto);</li>
                <li>L/P Aberto;</li>
                <li>L/P Fechado.</li>
              </ul>
            </li>
          </ul>
          <blockquote>
            <p><strong>Nota</strong>: A opção “<strong>Filtrar</strong>” será aplicada somente para o filtro
              “<strong>Ativo</strong>”, uma vez que após selecionar o filtro “<strong>Exibir posição do dia</strong>”,
              os
              ativos já serão filtrados com base na posição diária do investidor.</p>
          </blockquote>
          <h5 id="limpando-os-filtros-3">Limpando os filtros</h5>
          <p>Para apagar os parâmetros informados, selecione a opção “<strong>Limpar</strong>”.</p>
          <h4 *ngIf="showPositionBMF" id="custódia-bmf">Custódia BM&amp;F</h4>
          <p *ngIf="showPositionBMF">Na aba “<strong>BM&amp;F</strong>” na tela de Consulta de custódia, você poderá ver
            todas as informações
            referentes aos ativos adquiridos no mercado BM&amp;F da Bolsa de Valores.</p>
          <p *ngIf="showPositionBMF"><img src="assets/images/clients/{{broker}}/manual/IMG_49.png" alt=""
              title="Custódia BM&amp;F"></p>
          <h5 *ngIf="showPositionBMF" id="colunas-disponíveis-3">Colunas disponíveis</h5>
          <p *ngIf="showPositionBMF">As <strong>colunas</strong> disponíveis na aba de <strong>Consulta
              BM&amp;F</strong>, apresentam as
            seguintes
            informações:</p>
          <ul *ngIf="showPositionBMF">
            <li>Ativo;</li>
            <li>Quantidade Inicial (Qtd Inicial):</li>
            <li>Posição;</li>
            <li>Compras Executadas (Compras Exec);</li>
            <li>Vendas Executadas (Vendas Exec;</li>
            <li>Preço Atual;</li>
            <li>Preço Fechamento (Preço Fech.);</li>
            <li>Ajuste de Posição.</li>
          </ul>
          <h5 *ngIf="showPositionBMF" id="filtros-disponíveis-3">Filtros disponíveis</h5>
          <p *ngIf="showPositionBMF">Os filtros disponíveis na aba de <strong>Consulta BM&amp;F</strong> são:</p>
          <ul *ngIf="showPositionBMF">
            <li><strong>Ativo</strong>: campo para buscar pelo símbolo do ativo e para aplicar o filtro, selecione a
              opção
              “<strong>Filtrar</strong>”;</li>
            <li><strong>Exibir posição do dia</strong>: ação para exibir qual a posição do investidor diária em relação
              a
              cada ativo. As colunas exibidas após a seleção do filtro “exibir posição do dia” são alteradas, sendo
              apresentadas da seguinte maneira:
              <ul>
                <li>Ativo;</li>
                <li>Compra Executada no Dia (Compra Exec. Dia);</li>
                <li>Venda Executada no Dia (Venda Exec. Dia);</li>
                <li>NET no dia (NET Dia);</li>
                <li>Preço médio aberto (Pr. Med. Aberto);</li>
                <li>L/P Aberto;</li>
                <li>L/P Fechado.</li>
              </ul>
            </li>
          </ul>
          <blockquote *ngIf="showPositionBMF">
            <p><strong>Nota</strong>: A opção “<strong>Filtrar</strong>” será aplicada somente para o filtro
              “<strong>Ativo</strong>”, uma vez que após selecionar o filtro “<strong>Exibir posição do dia</strong>”,
              os
              ativos já serão filtrados com base na posição diária do investidor.</p>
          </blockquote>
          <h5 *ngIf="showPositionBMF" id="limpando-os-filtros-4">Limpando os filtros</h5>
          <p *ngIf="showPositionBMF">Para apagar os parâmetros informados, selecione a opção “<strong>Limpar</strong>”.
          </p>

          <h4 *ngIf="showPositionEarnings" id="proventos">Proventos</h4>
          <p *ngIf="showPositionEarnings">Na aba “<strong>Proventos</strong>” na tela de Consulta de custódia, você
            poderá ver todas as informações
            referentes aos seus proventos. </p>

          <h5 *ngIf="showPositionEarnings" id="colunas-disponíveis-4">Colunas disponíveis</h5>
          <p *ngIf="showPositionEarnings"> As colunas disponíveis na aba de “<strong>Proventos</strong>" estarão
            disponíveis em breve. </p>

          <h5 id="filtros-disponíveis-4">Filtros disponíveis</h5>
          <p>Os filtros disponíveis na aba de Proventos estarão disponíveis em breve.</p>


          <h4 id="visualizar-posição-do-dia-através-da-área-de-trabalho">Visualizar Posição do Dia através
            da
            Área de Trabalho</h4>
          <p>É possível visualizar a sua posição do dia em relação a cada ativo operado através da
            ferramenta
            de <strong>Posição do Dia</strong> que pode ser acessada diretamente na sua área de trabalho.</p>
          <p>As colunas exibidas são as mesmas apresentadas na opção “Posição do Dia”, presente das abas
            Bovespa e BMF no menu de Custódia.</p>
          <p>Você também poderá alternar entre duas formas de visualização da Posição do Dia, podendo visualizar de
            forma
            <strong>Resumida</strong> ou <strong>Detalhada</strong>.
          </p>
          <p><img src="assets/images/clients/{{broker}}/manual/IMG_56.png" alt="" title="Ferramenta de Posição do Dia">
          </p>

          <h3 id="nota-de-corretagem" *ngIf="showSideBarBrokerageNote">Nota de corretagem</h3>
          <p *ngIf="showSideBarBrokerageNote">Na tela de Nota de Corretagem, o investidor poderá consultar o valor total
            de suas operações realizadas na
            bolsa, quais os ativos foram adquiridos ou vendidos, todas as taxas envolvidas na operação, o valor da
            corretagem e a soma total, tudo isso podendo ser conferido através de um documento, que você poderá acessar
            informado a data de sua escolha com base no filtro disponível.</p>
          <p *ngIf="showSideBarBrokerageNote"><img src="assets/images/clients/{{broker}}/manual/IMG_64.png" alt=""
              title="Nota de corretagem"></p>
          <h4 *ngIf="showSideBarBrokerageNote" id="filtrando-as-notas-de-corratagem">Filtrando as notas de corratagem
          </h4>
          <p *ngIf="showSideBarBrokerageNote">Para buscar uma nota de corretagem através de um mercado específico,
            selecione no campo
            “<strong>Mercado</strong>” entre <strong>Bovespa</strong> e <strong>BMF</strong>.</p>
          <p>Além disso, você deve selecionar uma <strong>data de operação</strong> no campo <strong>Data</strong> e em
            seguida, selecione a opção “<strong>Buscar</strong>”.</p>
          <h3 *ngIf="showSideBarExtract" id="extrato">Extrato</h3>
          <p>Na tela de Extrato, o investidor poderá consultar toda as movimentações que foram realizadas na sua conta,
            consultando os valores que foram obtidos através de operações de compra e venda, resgates em algum tipo de
            operação, depósitos na sua conta e outras informações, que você poderá acessar informado a data de sua
            escolha com base no filtro disponível.</p>
          <p *ngIf="showSideBarExtract"><img src="assets/images/clients/{{broker}}/manual/IMG_65.png" alt=""
              title="Extrato"></p>
          <h4 *ngIf="showSideBarExtract" id="filtrando-os-extratos-de-movimentação">Filtrando os extratos de
            movimentação</h4>
          <p *ngIf="showSideBarExtract">Para buscar um extrato através de um mercado específico, selecione no campo
            “<strong>Mercado</strong>”
            entre <strong>Bovespa</strong> e <strong>BMF</strong>.</p>
          <p *ngIf="showSideBarExtract">Além disso, você deve selecionar uma <strong>data inicial</strong> e uma
            <strong>data final</strong> no
            campo “<strong>selecione um período desejado</strong>”. Em seguida, selecione a opção
            “<strong>Confirmar</strong>”.
          </p>
          <p *ngIf="showSideBarExtract">Para realizara a busca dos seus extratos, selecione a opção
            <strong>Buscar</strong>.
          </p>

          <h3 *ngIf="showSideBarMenuDeposit" id="resgate-e-depósito">Resgate e Depósito
          </h3>
          <p *ngIf="showSideBarMenuDeposit">Na tela de Retirar/Informar Depósito, você
            poderá realizar a transferência do valor de sua escolha que você
            possui em
            um determinado ativo ou depositar um valor para que você possa continuar operando no seu Home Broker.</p>
          <p *ngIf="showSideBarMenuDeposit">Note que ao entrar nessa tela, sempre serão exibidas informações do horário
            sobre o
            funcionamento de retirada dos recursos disponíveis em sua conta.</p>
          <h4 *ngIf="showSideBarMenuDeposit" id="informações-a-serem-preenchidas-para-o-retirada">
            Informações a serem preenchidas para o retirada
          </h4>
          <p *ngIf="showSideBarMenuDeposit"><img src="assets/images/clients/{{broker}}/manual/IMG_66.png" alt=""
              title="Retirada"></p>
          <p *ngIf="showSideBarMenuDeposit">Para realizar a retirada você deverá informar
            as seguintes informações:</p>
          <ul *ngIf="showSideBarMenuDeposit">
            <li>
              <p><strong>Favorecido</strong>: nome do favorecido da conta onde será depositado o valor da retirada;</p>
            </li>
            <li>
              <p><strong>Origem</strong>: nome do ativo do qual será resgatado o valor desejado;</p>
            </li>
            <li>
              <p><strong>Banco</strong>: nome e/ou código do banco onde será depositado o valor da retirada;</p>
            </li>
            <li>
              <p><strong>Agência</strong>: código da agência do banco sem o dígito verificador;</p>
            </li>
            <li>
              <p><strong>Conta</strong>: número da conta do banco com o dígito verificador;</p>
            </li>
            <li>
              <p><strong>Retirada total</strong>: opção para selecionar em casos onde o valor da retirada deve ser o
                valor total;</p>
            </li>
            <li>
              <p><strong>Valor</strong>: opção para informar o valor a ser retirado (caso a opção “Retirada total” seja
                marcada,
                o campo valor será preenchido automaticamente);</p>
            </li>
            <li>
              <p><strong>Valor por extenso</strong>: opção para informar o valor a ser retirado escrito por extenso;</p>
            </li>
            <li>
              <p><strong>Observação</strong>: caso queira fazer alguma anotação relacionada ao resgate.</p>
            </li>
          </ul>
          <p *ngIf="showSideBarMenuDeposit">Após informar todos os campos, selecione a
            opção “Transferir” para confirmar a operação.</p>

          <h4 *ngIf="showSideBarMenuDeposit" id="informações-a-serem-preenchidas-para-o-retirada-1">Informações a serem
            preenchidas para o retirada
          </h4>
          <p *ngIf="showSideBarMenuDeposit"><img src="assets/images/clients/{{broker}}/manual/IMG_67.png" alt=""
              title="Depósito"></p>
          <p *ngIf="showSideBarMenuDeposit">Para realizar um depósito você deverá informar
            as seguintes informações:</p>
          <ul *ngIf="showSideBarMenuDeposit">
            <li>
              <p><strong>Banco</strong>: nome e/ou código do banco onde será debitado o valor do depósito;</p>
            </li>
            <li>
              <p><strong>Agência</strong>: código da agência do banco sem o dígito verificador;</p>
            </li>
            <li>
              <p><strong>Conta</strong>: número da conta do banco com o dígito verificador;</p>
            </li>
            <li>
              <p><strong>Origem</strong>: nome do ativo onde será depositado o valor desejado;</p>
            </li>
            <li>
              <p><strong>Valor</strong>: opção para informar o valor a ser depositado.</p>
            </li>
          </ul>
          <p *ngIf="showSideBarMenuDeposit">Após informar todos os campos, selecione a
            opção “Informar Depósito” para confirmar a operação.</p>
          <h1 id="entre-em-contato-com-nossa-equipe">Entre em contato com nossa equipe</h1>
          <p>Caso necessite de ajuda em qualquer ponto sobre a nossa plataforma, você pode entrar em contato com nossa
            equipe ou acessar nosso FAQ, onde o contato e o endereço para resolver suas dúvidas podem ser encontrados no
            menu lateral do <strong>Home Broker</strong>.</p>
          <h3 id="canais" *ngIf="wlConfig?.contact?.ombudsmanPhone">Canais de atendimento</h3>
          <ul>
            <li *ngIf="wlConfig?.contact?.ombudsmanPhone?.phoneNumber">
              <strong>{{ wlConfig?.contact?.ombudsmanPhone?.phoneInfo }}:&nbsp;</strong>{{
              wlConfig?.contact?.ombudsmanPhone?.phoneNumber }}
            </li>
            <li *ngIf="wlConfig?.contact?.ombudsmanPhone?.phoneMoreInfo">
              <strong>{{ wlConfig?.contact?.ombudsmanPhone?.moreInfo }}:&nbsp;</strong>{{
              wlConfig?.contact?.ombudsmanPhone?.phoneMoreInfo }}
            </li>
            <li *ngIf="wlConfig?.contact?.ombudsmanPhone?.sacPhone">
              <strong>{{ wlConfig?.contact?.ombudsmanPhone?.sacInfo }}:&nbsp;</strong>{{
              wlConfig?.contact?.ombudsmanPhone?.sacPhone
              }}
            </li>
            <li *ngIf="wlConfig?.contact?.ombudsmanPhone?.phoneOmbudsman">
              <strong>{{ wlConfig?.contact?.ombudsmanPhone?.ombudsman }}:&nbsp;</strong>{{
              wlConfig?.contact?.ombudsmanPhone?.phoneOmbudsman }}
            </li>
            <li *ngIf="wlConfig?.contact?.ombudsmanPhone?.phoneHearingImpaired">
              <strong>{{ wlConfig?.contact?.ombudsmanPhone?.HearingImpaired }}:&nbsp;</strong>{{
              wlConfig?.contact?.ombudsmanPhone?.phoneHearingImpaired }}
            </li>
            <li *ngIf="wlConfig?.contact?.email">
              <strong>E-mail:&nbsp;</strong>{{ wlConfig?.contact?.email }}
            </li>
          </ul>
          <blockquote>
            <p><strong>Nota</strong>: A medida que novas funcionalidades forem implementadas, nosso manual será
              atualizado
              com todas as informações para você se manter sempre por dentro das novidades.</p>
          </blockquote>
        </div>
      </div>
    </div>
    <button id="btn-scroll" class="btn-scroll btn-hidden" (click)="scrollTop()">
      <mat-icon>expand_less</mat-icon>
    </button>
  </div>
</div>
